/* eslint-disable no-unused-vars,max-len */
import monkeyify from 'monkeyify';
import _ from 'lodash';
import Blockly from 'blockly';
import { nanoid } from 'nanoid';
import { debounce } from 'debounce-decorator';
import classRoomStore from 'store/classRoomStore';
import pathfindingStore from 'store/pathfindingStore';
import userStore from 'store/userStore';
import blocklyStore from 'store/blocklyStore';
import threeDModelStatehook from 'store/threeDModelStatehook';
import classRoomStudentsStatehook from 'store/classRoomStudentsStatehook';
// import classroomHook from 'store/statehook/classroomHook';
import ClassroomHookClass from 'store/statehook/classroomHook';
import debug from 'debug';
import { getNS } from '_i18n_';
import {
  DISTANCE_SENSOR_ID,
  sensorSpecs,
  TEMPERATURE_SENSOR_ID,
} from '../../../sensor_specs';
import mapSpecs from '../../../map_specs';
import { IR_COMMANDS, GESTURES, RTTTL_SONGS, MATRIX_8_8_LIST } from '../../../dictionary';

const KEY_I18N_ROOT_NS = 'blocks/definition.js';

const _t = getNS(KEY_I18N_ROOT_NS);

const log = debug('ui:blockly');

// HSV
const COLOR_CONTROL = '#127AD4'; // 208
const COLOR_MOTION = '#E0158B'; // 326
const COLOR_POSITION = '#E765B5';
const COLOR_ONBOARD_ULTRASONIC = '#847D56';
const COLOR_SENSING = '#D63D18'; // 12
const COLOR_EVENTS = '#197B1B'; // 122
const COLOR_SIGHT = '#5EC3D6'; // '#257E9B';
const COLOR_SIGHT_INPUT = '#0C9EB5'; // '#257E9B';
const COLOR_SOUND = '#CE57B3'; // '#90120B'; // 326
const COLOR_LOGIC = '#51759B';
const COLOR_ONBOARD_GRIPPER = '#D5A615';
const COLOR_ACTION = '#F6BE00';
const COLOR_IR = '#EAA794';
const COLOR_ENVIRONMENTAL = '#A7C54C'; // 12
const COLOR_WARNING = '#FBBD08';
const COLOR_MICROBIT = '#34EB7D';
const COLOR_SANDBOX = '#00B87A';
const COLOR_SANDBOX_TEACHER_ONLY = '#1AC548';
const IMAGE_SRC_LOOP =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' width='40px' height='40px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M437.012,74.99C390.686,28.662,326.693,0,256,0C146.256,0,52.655,69.064,16.251,166.094l59.938,22.477 C103.491,115.798,173.692,64,256,64c53.02,0,101.01,21.5,135.754,56.247L320,192h192V0L437.012,74.99z M256,448 c-53.02,0-101.013-21.496-135.756-56.244L192,320H0v192l74.997-74.997C121.32,483.334,185.306,512,256,512 c109.744,0,203.346-69.064,239.75-166.094l-59.938-22.477C408.51,396.202,338.309,448,256,448z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E";
const IMAGE_SRC_POSITION =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 55.017 55.017' style='enable-background:new 0 0 55.017 55.017;' xml:space='preserve' width='40px' height='40px'%3E%3Cg%3E%3Cpath fill='white' d='M51.688,23.013H40.789c-0.553,0-1,0.447-1,1s0.447,1,1,1h9.102l2.899,27H2.268l3.403-27h9.118c0.553,0,1-0.447,1-1 s-0.447-1-1-1H3.907L0,54.013h55.017L51.688,23.013z'/%3E%3Cpath fill='white' d='M26.654,38.968c-0.147,0.087-0.304,0.164-0.445,0.255c-0.22,0.142-0.435,0.291-0.646,0.445 c-0.445,0.327-0.541,0.953-0.215,1.398c0.196,0.267,0.5,0.408,0.808,0.408c0.205,0,0.412-0.063,0.591-0.193 c0.178-0.131,0.359-0.257,0.548-0.379c0.321-0.208,0.662-0.403,1.014-0.581c0.468-0.237,0.658-0.791,0.462-1.269 c0.008-0.008,0.018-0.014,0.025-0.022c1.809-1.916,7.905-9.096,10.429-21.058c0.512-2.426,0.627-4.754,0.342-6.919 c-0.86-6.575-4.945-10.051-11.813-10.051c-6.866,0-10.951,3.476-11.813,10.051c-0.284,2.166-0.169,4.494,0.343,6.919 C18.783,29.818,24.783,36.97,26.654,38.968z M17.924,11.314c0.733-5.592,3.949-8.311,9.831-8.311c5.883,0,9.098,2.719,9.83,8.311 c0.255,1.94,0.148,4.043-0.316,6.247C35,28.314,29.59,35.137,27.755,37.207c-1.837-2.072-7.246-8.898-9.514-19.646 C17.776,15.357,17.67,13.255,17.924,11.314z'/%3E%3Cpath fill='white' d='M27.755,19.925c4.051,0,7.346-3.295,7.346-7.346s-3.295-7.346-7.346-7.346s-7.346,3.295-7.346,7.346 S23.704,19.925,27.755,19.925z M27.755,7.234c2.947,0,5.346,2.398,5.346,5.346s-2.398,5.346-5.346,5.346s-5.346-2.398-5.346-5.346 S24.808,7.234,27.755,7.234z'/%3E%3Cpath fill='white' d='M31.428,37.17c-0.54,0.114-0.884,0.646-0.769,1.187c0.1,0.47,0.515,0.791,0.977,0.791c0.069,0,0.14-0.007,0.21-0.022 c0.586-0.124,1.221-0.229,1.886-0.313c0.548-0.067,0.938-0.567,0.869-1.115c-0.068-0.549-0.563-0.945-1.115-0.869 C32.763,36.918,32.07,37.033,31.428,37.17z'/%3E%3Cpath fill='white' d='M36.599,37.576c0.022,0.537,0.466,0.957,0.998,0.957c0.015,0,0.029,0,0.044-0.001l2.001-0.083 c0.551-0.025,0.979-0.493,0.953-1.044c-0.025-0.553-0.539-0.984-1.044-0.954l-1.996,0.083 C37.003,36.557,36.575,37.023,36.599,37.576z'/%3E%3Cpath fill='white' d='M22.433,42.177c-0.514,0.388-1.045,0.761-1.58,1.107c-0.463,0.301-0.595,0.92-0.294,1.384 c0.191,0.295,0.513,0.455,0.84,0.455c0.187,0,0.375-0.052,0.544-0.161c0.573-0.372,1.144-0.772,1.695-1.188 c0.44-0.333,0.528-0.96,0.196-1.401C23.501,41.936,22.876,41.844,22.433,42.177z'/%3E%3Cpath fill='white' d='M44.72,35.583c-0.338,0.237-0.777,0.409-1.346,0.526c-0.541,0.111-0.889,0.641-0.777,1.182 c0.098,0.473,0.514,0.798,0.979,0.798c0.067,0,0.135-0.007,0.203-0.021c0.842-0.174,1.526-0.452,2.096-0.853l0.134-0.098 c0.44-0.334,0.527-0.961,0.194-1.401c-0.334-0.44-0.96-0.526-1.401-0.194L44.72,35.583z'/%3E%3Cpath fill='white' d='M8.86,43.402c0.145-0.533-0.171-1.082-0.704-1.226c-0.529-0.149-1.082,0.169-1.226,0.704 c-0.126,0.464-0.201,0.938-0.225,1.405C6.7,44.4,6.697,44.516,6.697,44.638c0.001,0.196,0.01,0.392,0.029,0.587 c0.053,0.515,0.487,0.898,0.994,0.898c0.033,0,0.067-0.002,0.103-0.005c0.549-0.057,0.949-0.547,0.894-1.097 c-0.014-0.131-0.019-0.264-0.02-0.39c0-0.083,0.003-0.166,0.007-0.248C8.72,44.059,8.772,43.728,8.86,43.402z'/%3E%3Cpath fill='white' d='M44.698,27.81c-0.794-0.106-1.604-0.041-2.386,0.181c-0.532,0.149-0.841,0.702-0.69,1.233 c0.124,0.441,0.525,0.729,0.961,0.729c0.091,0,0.182-0.012,0.272-0.038c0.52-0.146,1.055-0.192,1.575-0.122 c0.562,0.07,1.052-0.311,1.125-0.857C45.629,28.387,45.245,27.884,44.698,27.81z'/%3E%3Cpath fill='white' d='M46.688,32.764c-0.163,0.527,0.133,1.088,0.66,1.25c0.099,0.031,0.197,0.045,0.295,0.045c0.428,0,0.823-0.275,0.955-0.705 c0.099-0.318,0.16-0.641,0.183-0.963c0.005-0.083,0.008-0.167,0.008-0.25c0-0.468-0.086-0.937-0.255-1.392 c-0.192-0.519-0.771-0.781-1.285-0.59c-0.519,0.192-0.782,0.768-0.59,1.285c0.086,0.232,0.13,0.467,0.13,0.696l-0.003,0.117 C46.774,32.423,46.742,32.589,46.688,32.764z'/%3E%3Cpath fill='white' d='M17.481,45.164c-0.586,0.275-1.183,0.53-1.774,0.759c-0.515,0.198-0.771,0.777-0.572,1.293 c0.153,0.396,0.531,0.64,0.933,0.64c0.12,0,0.242-0.021,0.36-0.067c0.635-0.245,1.275-0.519,1.903-0.813 c0.5-0.234,0.715-0.83,0.48-1.33C18.578,45.145,17.984,44.928,17.481,45.164z'/%3E%3Cpath fill='white' d='M10.201,41.001c0.161,0,0.325-0.039,0.478-0.122c0.288-0.157,0.595-0.255,0.911-0.289c0.135-0.016,0.273-0.016,0.406,0.002 c0.563,0.073,1.05-0.313,1.122-0.86c0.072-0.548-0.313-1.05-0.86-1.122c-0.298-0.039-0.601-0.041-0.891-0.008 c-0.574,0.063-1.128,0.239-1.646,0.521c-0.485,0.265-0.664,0.871-0.399,1.356C9.504,40.813,9.847,41.001,10.201,41.001z'/%3E%3Cpath fill='white' d='M9.993,48.842c0.216,0.056,0.436,0.098,0.654,0.124c0.256,0.031,0.512,0.047,0.769,0.047c0.313,0,0.627-0.022,0.94-0.062 c0.548-0.069,0.937-0.569,0.867-1.117s-0.567-0.934-1.117-0.867c-0.404,0.052-0.812,0.064-1.216,0.015 c-0.132-0.017-0.264-0.042-0.394-0.075c-0.535-0.143-1.08,0.181-1.22,0.716C9.139,48.158,9.459,48.704,9.993,48.842z'/%3E%3C/g%3E%3C/svg%3E%0A";
const IMAGE_SRC_PRINT =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 482.5 482.5' style='enable-background:new 0 0 482.5 482.5;' xml:space='preserve' width='40px' height='40px'%3E%3Cg%3E%3Cpath d='M399.25,98.9h-12.4V71.3c0-39.3-32-71.3-71.3-71.3h-149.7c-39.3,0-71.3,32-71.3,71.3v27.6h-11.3 c-39.3,0-71.3,32-71.3,71.3v115c0,39.3,32,71.3,71.3,71.3h11.2v90.4c0,19.6,16,35.6,35.6,35.6h221.1c19.6,0,35.6-16,35.6-35.6 v-90.4h12.5c39.3,0,71.3-32,71.3-71.3v-115C470.55,130.9,438.55,98.9,399.25,98.9z M121.45,71.3c0-24.4,19.9-44.3,44.3-44.3h149.6 c24.4,0,44.3,19.9,44.3,44.3v27.6h-238.2V71.3z M359.75,447.1c0,4.7-3.9,8.6-8.6,8.6h-221.1c-4.7,0-8.6-3.9-8.6-8.6V298h238.3 V447.1z M443.55,285.3c0,24.4-19.9,44.3-44.3,44.3h-12.4V298h17.8c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-330 c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h19.9v31.6h-11.3c-24.4,0-44.3-19.9-44.3-44.3v-115c0-24.4,19.9-44.3,44.3-44.3h316 c24.4,0,44.3,19.9,44.3,44.3V285.3z' fill='%23FFFFFF'/%3E%3Cpath d='M154.15,364.4h171.9c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-171.9c-7.5,0-13.5,6-13.5,13.5S146.75,364.4,154.15,364.4 z' fill='%23FFFFFF'/%3E%3Cpath d='M327.15,392.6h-172c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h171.9c7.5,0,13.5-6,13.5-13.5S334.55,392.6,327.15,392.6z' fill='%23FFFFFF'/%3E%3Cpath d='M398.95,151.9h-27.4c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h27.4c7.5,0,13.5-6,13.5-13.5S406.45,151.9,398.95,151.9z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E";
const IMAGE_SRC_RGB =
  "data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3E%3Ccircle style='fill:%23006DF0;' cx='355.225' cy='341.5' r='156.775'/%3E%3Ccircle style='fill:%23D80027;' cx='255.53' cy='170.5' r='156.775'/%3E%3Ccircle style='fill:%2391DC5A;' cx='156.775' cy='341.5' r='156.775'/%3E%3Cpath style='fill:%23FFFFFF;' d='M399.023,199.001c0,0-100.395-13.715-143.023,21.116c-42.88-35.039-142.023-21.116-142.023-21.116 s34.389,98.73,86.343,118.271c-8.463,54.14,55.184,124.018,55.681,124.018c0.499,0,64.229-70.123,55.621-124.374 C363.214,297.131,399.023,199.001,399.023,199.001z'/%3E%3Cpath style='fill:%23EA348B;' d='M256,220.117c14.291,11.678,26.754,26.087,36.53,43.019c9.888,17.128,16.168,35.347,19.092,53.78 c51.591-19.786,90.066-66.045,98.784-122.155C357.575,174.829,298.627,185.286,256,220.117z'/%3E%3Cpath style='fill:%2399EFF2;' d='M311.624,316.916c-17.426,6.683-36.343,10.356-56.121,10.356c-19.423,0-38.015-3.54-55.182-9.999 c-8.463,54.14,12.08,110.071,55.681,145.633C299.699,427.266,320.232,371.167,311.624,316.916z'/%3E%3Cpath style='fill:%23FFDA44;' d='M200.32,317.272c2.9-18.554,9.198-36.898,19.152-54.136c9.774-16.932,22.238-31.339,36.529-43.019 c-42.88-35.039-102.273-45.415-155.344-25.003C109.535,251.405,148.367,297.731,200.32,317.272z'/%3E%3Cpath style='fill:%23FFFFFF;' d='M256,220.117c-14.291,11.678-26.753,26.087-36.529,43.019c-9.952,17.24-16.251,35.584-19.152,54.136 c17.167,6.458,35.759,9.999,55.182,9.999c19.778,0,38.695-3.671,56.121-10.356c-2.926-18.434-9.204-36.653-19.092-53.78 C282.756,246.204,270.292,231.797,256,220.117z'/%3E%3C/svg%3E";
const IMAGE_SRC_WAIT =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' width='40px' height='40px' viewBox='0 0 485.563 485.562' style='enable-background:new 0 0 485.563 485.562;' xml:space='preserve'%3E%3Cg%3E%3Cg id='Layer_2_18_'%3E%3Cg%3E%3Cpath d='M311.409,251.414c5.32-1.537,17.778-5.145,23.569-22.177l11.931-35.086l4.799,1.63c2.197,0.748,4.605-0.438,5.353-2.635 l6.401-18.824c0.748-2.197-0.438-4.604-2.637-5.351l-154.671-52.592c-2.196-0.747-4.606,0.44-5.353,2.636l-6.401,18.823 c-0.746,2.196,0.441,4.604,2.636,5.352l4.799,1.632l-12.145,35.725c-5.735,16.865-1.941,22.56,5.255,31.179l31.299,37.48 l-3.489,10.26c-11.976,2.599-43.272,9.418-47.485,10.635c-5.319,1.539-17.78,5.143-23.572,22.177l-10.271,30.21l-4.8-1.631 c-2.195-0.747-4.606,0.438-5.354,2.635l-6.398,18.823c-0.748,2.197,0.439,4.604,2.636,5.353l154.672,52.593 c2.194,0.746,4.604-0.44,5.352-2.638l6.397-18.82c0.749-2.197-0.437-4.606-2.636-5.354l-4.797-1.632l10.486-30.849 c5.735-16.863,1.944-22.561-5.254-31.176l-31.297-37.481l3.486-10.26C275.897,259.453,307.193,252.635,311.409,251.414z M246.043,278.771l34.035,40.753c2.611,3.127,3.994,4.834,4.369,6.397c0.451,1.877-0.152,5.201-1.838,10.156l-10.488,30.851 l-116.316-39.55l10.269-30.209c3.243-9.535,9.122-11.237,13.413-12.479c3.356-0.97,32.146-7.282,50.679-11.291 c2.604-0.563,4.725-2.454,5.583-4.978l6.245-18.365c0.851-2.508,0.337-5.277-1.36-7.31l-33.932-40.631l-0.103-0.125 c-2.612-3.127-3.995-4.834-4.369-6.398c-0.45-1.877,0.15-5.198,1.837-10.156l12.146-35.725l116.319,39.55L320.6,224.348 c-3.241,9.537-9.118,11.237-13.41,12.479c-3.354,0.971-32.145,7.285-50.676,11.291c-2.605,0.564-4.728,2.453-5.587,4.979 l-6.243,18.363C243.831,273.969,244.348,276.736,246.043,278.771z' fill='%23FFFFFF'/%3E%3Cpath d='M337.935,423.581c-3.395,1.924-6.896,3.766-10.399,5.474c-0.567,0.277-1.114,0.58-1.643,0.907 c-0.562,0.195-1.121,0.422-1.676,0.68c-15.206,7.09-31.062,12.082-47.396,14.977c-0.209,0.03-0.418,0.042-0.629,0.08 c-3.851,0.681-7.77,1.248-11.646,1.692c-0.042,0.007-0.085,0.017-0.127,0.022c-7.118,0.785-14.316,1.186-21.589,1.186 c-83.862,0-155.381-53.81-181.88-128.71c-0.399-1.143-0.801-2.283-1.18-3.428c-6.352-19.101-9.802-39.515-9.802-60.722 c0-21.251,3.465-41.71,9.844-60.846c0.139-0.418,0.273-0.833,0.414-1.252c0.381-1.114,0.775-2.224,1.177-3.331 c0.187-0.52,0.376-1.037,0.568-1.553c22.02-59.268,72.388-104.863,134.541-120.242c0.039-0.009,0.079-0.012,0.118-0.021 c0.919-0.228,1.845-0.45,2.772-0.664c0.104-0.023,0.204-0.061,0.304-0.086c13.559-3.108,27.658-4.779,42.126-4.853l0.167,19.829 c0.051,6.156,3.938,7.934,8.632,3.955l41.886-35.504c4.693-3.979,4.643-10.43-0.123-14.33L249.92,2.045 c-4.762-3.899-8.616-2.056-8.564,4.099l0.167,19.79c-60.9,0.337-118.103,24.199-161.204,67.298 c-4.246,4.246-8.298,8.632-12.165,13.141c-0.023,0.026-0.047,0.047-0.071,0.075c-0.143,0.166-0.278,0.339-0.419,0.505 c-33.925,39.809-53.051,89.425-54.552,142.061c-0.037,0.409-0.081,0.815-0.091,1.233c-0.041,1.756-0.062,3.541-0.062,5.306 c0,2.894,0.059,5.827,0.168,8.72c0.012,0.339,0.056,0.67,0.089,1.003c1.944,47.958,18.527,93.3,47.621,130.856 c0.099,0.129,0.178,0.267,0.278,0.396c2.842,3.668,5.847,7.302,8.92,10.798c0.198,0.225,0.415,0.42,0.619,0.634 c3.111,3.508,6.323,6.944,9.666,10.286c34.123,34.124,77.088,56.187,123.726,64.068c0.142,0.026,0.285,0.054,0.427,0.08 c0.106,0.016,0.211,0.023,0.315,0.039c12.455,2.062,25.167,3.129,38.042,3.129c33.881,0,66.517-7.209,97.004-21.42 c0.657-0.306,1.281-0.657,1.882-1.028c0.683-0.235,1.354-0.514,2.016-0.837c4.183-2.042,8.361-4.236,12.412-6.529 c8.882-5.03,12.008-16.306,6.979-25.188C358.092,421.677,346.815,418.555,337.935,423.581z' fill='%23FFFFFF'/%3E%3Cpath d='M402.976,148.173c3.567,5.309,9.407,8.174,15.354,8.174c3.544,0,7.13-1.017,10.292-3.143 c8.471-5.693,10.723-17.174,5.03-25.646c-2.599-3.865-5.345-7.698-8.176-11.391c-6.2-8.108-17.798-9.65-25.905-3.45 c-8.106,6.202-9.65,17.802-3.446,25.907C398.496,141.725,400.801,144.938,402.976,148.173z' fill='%23FFFFFF'/%3E%3Cpath d='M426.446,196.708c1.188,3.711,2.279,7.516,3.247,11.311c2.131,8.36,9.648,13.921,17.896,13.921 c1.509,0,3.047-0.187,4.577-0.577c9.891-2.52,15.866-12.583,13.345-22.472c-1.15-4.513-2.45-9.04-3.866-13.456 c-3.11-9.72-13.514-15.079-23.233-11.965C428.69,176.584,423.333,186.988,426.446,196.708z' fill='%23FFFFFF'/%3E%3Cpath d='M414.674,380.14c-7.724-6.675-19.391-5.828-26.067,1.892c-2.556,2.956-5.232,5.869-7.958,8.657 c-7.134,7.301-6.998,19.001,0.304,26.136c3.595,3.513,8.257,5.263,12.913,5.263c4.803,0,9.602-1.862,13.221-5.566 c3.246-3.323,6.438-6.792,9.479-10.313C423.239,398.486,422.393,386.815,414.674,380.14z' fill='%23FFFFFF'/%3E%3Cpath d='M454.675,243.736c-10.219-0.307-18.722,7.719-19.024,17.92c-0.115,3.907-0.356,7.859-0.714,11.745 c-0.933,10.163,6.551,19.16,16.715,20.093c0.574,0.053,1.144,0.078,1.711,0.078c9.44,0,17.503-7.203,18.381-16.792 c0.426-4.639,0.714-9.354,0.852-14.019C472.897,252.562,464.878,244.041,454.675,243.736z' fill='%23FFFFFF'/%3E%3Cpath d='M446.456,315.401c-9.509-3.723-20.228,0.966-23.949,10.472c-1.423,3.635-2.978,7.28-4.623,10.828 c-4.29,9.26-0.261,20.244,9,24.535c2.517,1.166,5.157,1.717,7.758,1.717c6.978,0,13.654-3.97,16.78-10.716 c1.956-4.224,3.81-8.559,5.503-12.889C460.647,329.845,455.959,319.123,446.456,315.401z' fill='%23FFFFFF'/%3E%3Cpath d='M383.518,96.938c6.075-8.204,4.35-19.777-3.854-25.851c-3.735-2.767-7.608-5.454-11.51-7.992 c-8.557-5.563-20.004-3.139-25.567,5.418c-5.562,8.556-3.139,20.002,5.416,25.567c3.279,2.13,6.529,4.389,9.668,6.713 c3.306,2.447,7.161,3.629,10.984,3.629C374.311,104.422,379.895,101.833,383.518,96.938z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A";
const IMAGE_SRC_SOUND =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 477.216 477.216' style='enable-background:new 0 0 477.216 477.216;' xml:space='preserve' width='40px' height='40px'%3E%3Cg%3E%3Cpath d='M453.858,105.116v-91.6c0-4.3-2.1-8.4-5.5-10.9c-3.5-2.5-8-3.3-12.1-2l-272.9,86.7c-5.6,1.8-9.4,7-9.4,12.9v91.7v0.1v175.3 c-14.3-9.9-32.6-15.3-51.8-15.3c-20.3,0-39.6,6.1-54.3,17.1c-15.8,11.9-24.5,28-24.5,45.5s8.7,33.6,24.5,45.5 c14.7,11,33.9,17.1,54.3,17.1s39.6-6.1,54.3-17.1c15.8-11.9,24.5-28,24.5-45.5v-212.8l245.9-78.2v156.6 c-14.3-9.9-32.6-15.3-51.8-15.3c-20.3,0-39.6,6.1-54.3,17.1c-15.8,11.9-24.5,28-24.5,45.5s8.7,33.6,24.5,45.5 c14.7,11,33.9,17.1,54.3,17.1s39.6-6.1,54.3-17.1c15.8-11.9,24.5-28,24.5-45.5v-222.3 C453.858,105.116,453.858,105.116,453.858,105.116z M102.158,450.216c-28.1,0-51.8-16.3-51.8-35.6c0-19.3,23.7-35.6,51.8-35.6 s51.8,16.3,51.8,35.6C153.958,434.016,130.258,450.216,102.158,450.216z M180.958,173.416v-63.4l245.9-78.1v63.4L180.958,173.416z M375.158,363.116c-28.1,0-51.8-16.3-51.8-35.6c0-19.3,23.7-35.6,51.8-35.6s51.8,16.3,51.8,35.6 C426.858,346.816,403.158,363.116,375.158,363.116z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E%0A";
const IMAGE_SRC_EXTERNAL =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' viewBox='0 0 512.092 512.092' style='enable-background:new 0 0 512.092 512.092;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cpath d='M312.453,199.601c-6.066-6.102-12.792-11.511-20.053-16.128c-19.232-12.315-41.59-18.859-64.427-18.859 c-31.697-0.059-62.106,12.535-84.48,34.987L34.949,308.23c-22.336,22.379-34.89,52.7-34.91,84.318 c-0.042,65.98,53.41,119.501,119.39,119.543c31.648,0.11,62.029-12.424,84.395-34.816l89.6-89.6 c1.628-1.614,2.537-3.816,2.524-6.108c-0.027-4.713-3.87-8.511-8.583-8.484h-3.413c-18.72,0.066-37.273-3.529-54.613-10.581 c-3.195-1.315-6.867-0.573-9.301,1.877l-64.427,64.512c-20.006,20.006-52.442,20.006-72.448,0 c-20.006-20.006-20.006-52.442,0-72.448l108.971-108.885c19.99-19.965,52.373-19.965,72.363,0 c13.472,12.679,34.486,12.679,47.957,0c5.796-5.801,9.31-13.495,9.899-21.675C322.976,216.108,319.371,206.535,312.453,199.601z' fill='%2300FF00'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M477.061,34.993c-46.657-46.657-122.303-46.657-168.96,0l-89.515,89.429c-2.458,2.47-3.167,6.185-1.792,9.387 c1.359,3.211,4.535,5.272,8.021,5.205h3.157c18.698-0.034,37.221,3.589,54.528,10.667c3.195,1.315,6.867,0.573,9.301-1.877 l64.256-64.171c20.006-20.006,52.442-20.006,72.448,0c20.006,20.006,20.006,52.442,0,72.448l-80.043,79.957l-0.683,0.768 l-27.989,27.819c-19.99,19.965-52.373,19.965-72.363,0c-13.472-12.679-34.486-12.679-47.957,0 c-5.833,5.845-9.35,13.606-9.899,21.845c-0.624,9.775,2.981,19.348,9.899,26.283c9.877,9.919,21.433,18.008,34.133,23.893 c1.792,0.853,3.584,1.536,5.376,2.304c1.792,0.768,3.669,1.365,5.461,2.048c1.792,0.683,3.669,1.28,5.461,1.792l5.035,1.365 c3.413,0.853,6.827,1.536,10.325,2.133c4.214,0.626,8.458,1.025,12.715,1.195h5.973h0.512l5.12-0.597 c1.877-0.085,3.84-0.512,6.059-0.512h2.901l5.888-0.853l2.731-0.512l4.949-1.024h0.939c20.961-5.265,40.101-16.118,55.381-31.403 l108.629-108.629C523.718,157.296,523.718,81.65,477.061,34.993z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
const IMAGE_SRC_SERIAL =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' viewBox='0 0 512.092 512.092' style='enable-background:new 0 0 512.092 512.092;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cpath d='M312.453,199.601c-6.066-6.102-12.792-11.511-20.053-16.128c-19.232-12.315-41.59-18.859-64.427-18.859 c-31.697-0.059-62.106,12.535-84.48,34.987L34.949,308.23c-22.336,22.379-34.89,52.7-34.91,84.318 c-0.042,65.98,53.41,119.501,119.39,119.543c31.648,0.11,62.029-12.424,84.395-34.816l89.6-89.6 c1.628-1.614,2.537-3.816,2.524-6.108c-0.027-4.713-3.87-8.511-8.583-8.484h-3.413c-18.72,0.066-37.273-3.529-54.613-10.581 c-3.195-1.315-6.867-0.573-9.301,1.877l-64.427,64.512c-20.006,20.006-52.442,20.006-72.448,0 c-20.006-20.006-20.006-52.442,0-72.448l108.971-108.885c19.99-19.965,52.373-19.965,72.363,0 c13.472,12.679,34.486,12.679,47.957,0c5.796-5.801,9.31-13.495,9.899-21.675C322.976,216.108,319.371,206.535,312.453,199.601z' fill='%23FFFF00'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M477.061,34.993c-46.657-46.657-122.303-46.657-168.96,0l-89.515,89.429c-2.458,2.47-3.167,6.185-1.792,9.387 c1.359,3.211,4.535,5.272,8.021,5.205h3.157c18.698-0.034,37.221,3.589,54.528,10.667c3.195,1.315,6.867,0.573,9.301-1.877 l64.256-64.171c20.006-20.006,52.442-20.006,72.448,0c20.006,20.006,20.006,52.442,0,72.448l-80.043,79.957l-0.683,0.768 l-27.989,27.819c-19.99,19.965-52.373,19.965-72.363,0c-13.472-12.679-34.486-12.679-47.957,0 c-5.833,5.845-9.35,13.606-9.899,21.845c-0.624,9.775,2.981,19.348,9.899,26.283c9.877,9.919,21.433,18.008,34.133,23.893 c1.792,0.853,3.584,1.536,5.376,2.304c1.792,0.768,3.669,1.365,5.461,2.048c1.792,0.683,3.669,1.28,5.461,1.792l5.035,1.365 c3.413,0.853,6.827,1.536,10.325,2.133c4.214,0.626,8.458,1.025,12.715,1.195h5.973h0.512l5.12-0.597 c1.877-0.085,3.84-0.512,6.059-0.512h2.901l5.888-0.853l2.731-0.512l4.949-1.024h0.939c20.961-5.265,40.101-16.118,55.381-31.403 l108.629-108.629C523.718,157.296,523.718,81.65,477.061,34.993z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
const IMAGE_CHAT_BUBBLE =
  'data:image/svg+xml,%3Csvg%20id%3D%22Capa_1%22%20enable-background%3D%22new%200%200%20511.072%20511.072%22%20height%3D%22512%22%20viewBox%3D%220%200%20511.072%20511.072%22%20width%3D%22512%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20id%3D%22Speech_Bubble_48_%22%3E%3Cg%3E%3Cpath%20fill%3D%22%23ffffff%22%20d%3D%22m74.39%20480.536h-36.213l25.607-25.607c13.807-13.807%2022.429-31.765%2024.747-51.246-36.029-23.644-62.375-54.751-76.478-90.425-14.093-35.647-15.864-74.888-5.121-113.482%2012.89-46.309%2043.123-88.518%2085.128-118.853%2045.646-32.963%20102.47-50.387%20164.33-50.387%2077.927%200%20143.611%2022.389%20189.948%2064.745%2041.744%2038.159%2064.734%2089.63%2064.734%20144.933%200%2026.868-5.471%2053.011-16.26%2077.703-11.165%2025.551-27.514%2048.302-48.593%2067.619-46.399%2042.523-112.042%2065-189.83%2065-28.877%200-59.01-3.855-85.913-10.929-25.465%2026.123-59.972%2040.929-96.086%2040.929zm182-420c-124.039%200-200.15%2073.973-220.557%20147.285-19.284%2069.28%209.143%20134.743%2076.043%20175.115l7.475%204.511-.23%208.727c-.456%2017.274-4.574%2033.912-11.945%2048.952%2017.949-6.073%2034.236-17.083%2046.99-32.151l6.342-7.493%209.405%202.813c26.393%207.894%2057.104%2012.241%2086.477%2012.241%20154.372%200%20224.682-93.473%20224.682-180.322%200-46.776-19.524-90.384-54.976-122.79-40.713-37.216-99.397-56.888-169.706-56.888z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E';


Blockly.Constants.Loops.CUSTOMIZED_CONTROL_FLOW_IN_LOOP_CHECK_MIXIN = {
  LOOP_TYPES: [
    'customized_controls_repeat_ext',
    'customized_controls_for',
    'customized_controls_whileUntil',
  ],
  onchange() {
    if (this.workspace.isDragging && !this.workspace.isDragging()) {
      let a = !1;
      let b = this;
      do {
        if (this.LOOP_TYPES.indexOf(b.type) !== -1) {
          a = !0;
          break;
        }
        b = b.getSurroundParent();
      } while (b);
      if (a) {
        this.setWarningText(null);
      } else {
        this.setWarningText(Blockly.Msg.CONTROLS_FLOW_STATEMENTS_WARNING);
      }
    }
  },
};
Blockly.Extensions.registerMixin(
  'customized_controls_flow_in_loop_check',
  Blockly.Constants.Loops.CUSTOMIZED_CONTROL_FLOW_IN_LOOP_CHECK_MIXIN,
);

function hasRobotNumber(robot) {
  return robot && robot.numberVerified !== false && Number.isSafeInteger(robot.identifier) && robot.identifier >= 0;
}

function robotSortFunc(itA, itB) {
  const idA = parseInt(itA.identifier, 10);
  const idB = parseInt(itB.identifier, 10);
  if (idA > idB) return 1;
  if (idA < idB) return -1;
  return 0;
}

function objectSortFunc(itA, itB) {
  const idA = parseInt(itA.identifier, 10);
  const idB = parseInt(itB.identifier, 10);
  if (idA > idB) return 1;
  if (idA < idB) return -1;
  return 0;
}

export default function () {
  // region Teacher blocks
  function robotArg(block, name) {
    function dropdown(event) {
      const { classRoomCode } = classRoomStore;
      let robots = [['none', JSON.stringify({ text: 'none', value: '0' })]];
      if (
        classRoomStore.classRoomRobots.keys().length > 0 ||
        classRoomStore.classRoomObjects.keys().length > 0
      ) {
        robots = [];
        const robotsMaps = classRoomStore.classRoomRobots;
        robots = [].concat(
          robots,
          robotsMaps
            .values()
            .filter(hasRobotNumber)
            .sort(robotSortFunc)
            .map((it) => {
              const studentInfo = classRoomStudentsStatehook.findStudentByTheirRobotMacAddress(classRoomCode, it._id);
              const studentName = studentInfo ? ` - ${studentInfo.name}` : '';
              const itText = `🤖 ${it.identifier}${studentName}`;
              return [itText, JSON.stringify({
                text: itText,
                value: it.identifier.toString(),
              })];
            }),
        );
        const objectsMaps = classRoomStore.classRoomObjects;
        robots = [].concat(
          robots,
          objectsMaps
            .values()
            .sort(objectSortFunc)
            .map((it) => {
              const itText = `🎁 ${it.identifier}`;
              return [itText, JSON.stringify({
                text: itText,
                value: it.identifier.toString(),
              })];
            }),
        );
      } else {
        // remove the code below to avoid that there are a lot of console.log appear in console view
        // moved the check message to blockChecker.js
        // block.setWarningText('Please add robots for this classroom');
      }
      classRoomStore
        .getBlockErrorsByBlocklyId(block.id)
        .forEach(bE => block.setWarningText(bE.message));
      return robots.length ? robots : [['none', '0']];
    }
    return {
      type: 'field_dropdown',
      name: name || 'ROBOT',
      options: dropdown,
    };
  }

  function robotArgByRole(block, _extra) {
    const extra = _extra || {};
    const { blockAction } = extra;
    function dropdown() {
      const { classRoomCode } = classRoomStore;
      let robots = [['none', '0']];
      if (userStore.isAdmin || userStore.isTeacher || blockAction === 'read') {
        if (classRoomStore.classRoomRobots.keys().length > 0) {
          const robotsMaps = classRoomStore.classRoomRobots;
          robots = robotsMaps
            .values()
            .filter(hasRobotNumber)
            .sort(robotSortFunc)
            .map((it) => {
              const studentInfo = classRoomStudentsStatehook.findStudentByTheirRobotMacAddress(classRoomCode, it._id);
              const studentName = studentInfo ? ` - ${studentInfo.name}` : '';
              const itText = `🤖 ${it.identifier}${studentName}`;
              return [itText, JSON.stringify({
                text: itText,
                value: it.identifier.toString(),
              })];
            });
        } else {
          // remove the code below to avoid that there are a lot of console.log appear in console view
          // moved the check message to blockChecker.js
          // block.setWarningText('Please add robots for this classroom');
        }
      } else {
        const student = classRoomStudentsStatehook.getStudent(classRoomCode, userStore.currentUser._id);
        // const student = classRoomStore.classRoomStudents.find(s => s.student._id === userStore.currentUser._id);
        // robots = [['1','1']];
        if (student && student.robots && student.robots.length > 0) {
          robots = student.robots.filter(hasRobotNumber).sort(robotSortFunc).map((r) => {
            const studentInfo = classRoomStudentsStatehook.findStudentByTheirRobotMacAddress(classRoomCode, r._id);
            const studentName = studentInfo ? ` - ${studentInfo.name}` : '';
            const itText = `🤖 ${r.identifier}${studentName}`;
            return [
              itText,
              JSON.stringify({
                text: itText,
                value: r.identifier.toString(),
              }),
            ];
          });
        }
        log('Students Robots loaded in blockly', robots);
        if (robots.length === 0) {
          block.setWarningText(_t(['func:robotArgByRole', 'Please associate a robot to me']));
        }
      }
      classRoomStore
        .getBlockErrorsByBlocklyId(block.id)
        .forEach(bE => block.setWarningText(bE.message));
      return robots.length ? robots : [['none', '0']];
    }

    return {
      type: 'field_dropdown',
      name: 'ROBOT',
      options: dropdown,
    };
  }

  function placesArg() {
    function dropdown() {
      let places = [['none', '0']];
      pathfindingStore.applyPathfindingToCurrentWorkspaceByMapId(classRoomStore.mapId);
      const pfCurrent =
        pathfindingStore.pathfindingCurrentlyUsed &&
          pathfindingStore.pathfindingCurrentlyUsed.places
          ? pathfindingStore.pathfindingCurrentlyUsed.places.toJSON() || {}
          : mapSpecs[classRoomStore.mapId].places;

      const placesInMap = Object.keys(pfCurrent).map(p => [p, p]);
      // const placesInMap = Object.keys(mapSpecs[classRoomStore.mapId].places).map(p => [p, p]);
      // dynamic object as place
      placesInMap.push(...classRoomStore.classRoomObjects.values()
        .map(o => [`Object ${o.identifier}`, `$object:${o.identifier}`]));
      if (placesInMap.length > 0) {
        places = placesInMap;
      }
      return places;
    }
    return {
      type: 'field_dropdown',
      name: 'PLACE',
      options: dropdown,
    };
  }

  function robotArgBySensor(block, sensor) {
    let robots = [['none', '0']];
    if (classRoomStore.classRoomRobots.keys().length > 0) {
      const { classRoomCode } = classRoomStore;
      const robotsMaps = classRoomStore.classRoomRobots;
      const robotsWithSensor = robotsMaps
        .values()
        .filter((it) => {
          if (!hasRobotNumber(it) || !it.sensors) return false;
          const found = Object.values(it.sensors).find(sensorId => `S${sensorId}` === sensor);
          return !!found;
        })
        .sort(robotSortFunc)
        .map((it) => {
          const studentInfo = classRoomStudentsStatehook.findStudentByTheirRobotMacAddress(classRoomCode, it._id);
          const studentName = studentInfo ? ` - ${studentInfo.name}` : '';
          const itText = `🤖 ${it.identifier}${studentName}`;
          return [itText, JSON.stringify({
            text: itText,
            value: it.identifier.toString(),
          })];
        });
      if (robotsWithSensor.length > 0) {
        robots = robotsWithSensor;
      }
    } else {
      block.setWarningText('Please add sensors for robots');
    }
    classRoomStore
      .getBlockErrorsByBlocklyId(block.id)
      .forEach(bE => block.setWarningText(bE.message));
    return {
      type: 'field_dropdown',
      name: 'ROBOT',
      options: robots,
    };
  }

  function getStrongText(text) {
    const _tt = getNS([KEY_I18N_ROOT_NS, 'func:getBoldText']);
    return {
      type: 'field_label',
      text: _tt(text),
      class: 'blocklyLabel',
    };
  }

  function generate3DModelArg() {
    function dropdown() {
      let returnList = [['none', '']];
      let modelList = [];
      const { classRoomCode } = classRoomStore;
      let models = [];
      models = [].concat(models, threeDModelStatehook.get3DModelsFromClassroom(classRoomCode));
      if (Array.isArray(models) && models.length > 0) {
        modelList = models.filter(_one => !!_one.accepted_at).map((_one, _idx) => {
          const isGlobal = `${_one.namespace}`.toLowerCase() === 'global';
          let belongToName = '';
          if (isGlobal) {
            belongToName = ' (Global Library)';
          } else {
            belongToName = (_one.belongToAccount && _one.belongToAccount.name) || '';
            if (belongToName) {
              belongToName = ` / ${belongToName}`;
            }
          }
          const optionText = `${_one.modelTitle}${belongToName}`;
          return [optionText, JSON.stringify({
            text: optionText,
            value: `${_one.modelOBJZipURL}`,
          })];
        });
      }
      if (modelList.length > 0) {
        returnList = modelList;
      }
      return returnList;
    }
    const dropdownListId = nanoid();
    return {
      type: 'field_dropdown',
      name: 'THREE_D_MODEL_URL',
      options: dropdown,
      asyncOptions: (cb) => {
        const classroomHook = ClassroomHookClass.currentClassroomHook;
        const unwatchers = [];
        unwatchers.push(classroomHook.onUI3dModelDropdownListSelectedItem((eventType, eventData) => {
          const { modelData } = eventData;
          classroomHook.emitUI3dModelDropdownListClosed({ dropdownListId, modelData });
          const optionText = `${modelData.modelTitle} / ${_.get(modelData, 'created_by.name')}`;
          const optionValue = JSON.stringify({
            text: optionText,
            value: modelData.modelOBJZipURL,
          });
          cb(null, [[optionText, optionValue]], optionValue);
          while (unwatchers.length) unwatchers.pop()();
        }));
        unwatchers.push(classroomHook.onUI3dModelDropdownListClosed((eventType, eventData) => {
          eventData = eventData || {};
          const { modelData } = eventData;
          // debugger;
          if (modelData) {
            const optionValue = JSON.stringify({
              value: modelData.modelOBJZipURL,
              text: modelData.modelTitle,
            });

            cb(null, [[modelData.modelTitle, optionValue]], optionValue);
          } else {
            cb('closed');
          }
          while (unwatchers.length) unwatchers.pop()();
        }));
        classroomHook.emitUI3dModelDropdownListOpen({ dropdownListId });
        // setTimeout(() => {
        //   if (Math.random() * 10 < 5) {
        //     console.log('vvv error');
        //     cb('error 123', [['110', '110']], '110');
        //   } else {
        //     cb(null, [['110', '110']], '110');
        //   }
        // }, 3 * 1e3);
      },
    };
  }

  /**
   * Set global variable for class room
   * @see https://blockly-demo.appspot.com/static/demos/blockfactory/index.html#in3v6m
   * @type {{init: (function())}}
   */
  Blockly.Blocks.setConfig = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.setConfig']);
      const hasVariables =
        classRoomStore.globalVariables &&
        Object.keys(classRoomStore.globalVariables).length > 0;

      if (hasVariables) {
        const dropdownVariables = Object.entries(classRoomStore.globalVariables).reduce((acc, currPair) => {
          const [variableName, variableData] = currPair;
          if (
            typeof variableName !== 'string' &&
            typeof variableName !== 'number'
          ) return acc; // reject wrong data
          let variableNameLabel = variableName;
          if (
            !!variableData &&
            typeof variableData !== 'string' &&
            typeof variableData !== 'number'
          ) {
            if (variableData.readonly) {
              variableNameLabel = `${variableNameLabel}${_tt('(Student Read-Only)')}`;
              if (!userStore.isTeacher) return acc;
            }
          }
          acc.push([variableNameLabel, variableName]);
          return acc;
        }, []);
        this.appendDummyInput('NAME')
          .appendField(_tt('Set classroom variable'))
          .appendField(new Blockly.FieldDropdown(dropdownVariables), 'NAME');
      } else {
        this.appendDummyInput('NAME').appendField(_tt('Set classroom variable'));
        this.setTooltip(_tt('None variable created'));
      }
      // this.setPreviousStatement(true, null);
      this.setPreviousStatement(true, ['runProgram', 'any']);
      this.setNextStatement(true);
      this.appendValueInput('VALUE');
      // .setCheck('Number');
      this.setInputsInline(true);
      this.setColour(COLOR_CONTROL);
    },
  };

  /**
   * Get class room variable value
   * @se https://blockly-demo.appspot.com/static/demos/blockfactory/index.html#wqgm35
   * @type {{init: (function())}}
   */
  Blockly.Blocks.getConfig = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.getConfig']);
      const hasVariables =
        classRoomStore.globalVariables &&
        Object.keys(classRoomStore.globalVariables).length > 0;
      if (hasVariables) {
        const generateDropdown = () => {
          const dropdownVariables = Object.entries(classRoomStore.globalVariables).reduce((acc, currPair) => {
            const [variableName, variableData] = currPair;
            if (
              typeof variableName !== 'string' &&
              typeof variableName !== 'number'
            ) return acc; // reject wrong data
            let variableNameLabel = variableName;
            if (
              !!variableData &&
              typeof variableData !== 'string' &&
              typeof variableData !== 'number'
            ) {
              if (variableData.readonly) variableNameLabel = `${variableName}${_tt('(Read-Only)')}`;
            }
            acc.push([variableNameLabel, variableName]);
            return acc;
          }, []);
          return dropdownVariables;
        };
        this.appendDummyInput()
          .appendField(_tt('Classroom'))
          .appendField(new Blockly.FieldDropdown(generateDropdown), 'NAME')
          .appendField(_tt('value'));
      } else {
        this.appendDummyInput().appendField(_tt('Classroom'));
      }
      this.setOutput(true, null);
      this.setColour(COLOR_CONTROL);
    },
  };


  // used for replace Blockly.Blocks.getConfig
  Blockly.Blocks.get_classroom_variable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.get_classroom_variable']);
      const hasVariables =
        classRoomStore.globalVariables &&
        Object.keys(classRoomStore.globalVariables).length > 0;
      let generateDropdown = [['Undefined', 'undefined']];
      if (hasVariables) {
        generateDropdown = () => {
          const dropdownVariables = Object.entries(classRoomStore.globalVariables).reduce((acc, currPair) => {
            const [variableName, variableData] = currPair;
            if (
              typeof variableName !== 'string' &&
              typeof variableName !== 'number'
            ) return acc; // reject wrong data
            let variableNameLabel = variableName;
            if (
              !!variableData &&
              typeof variableData !== 'string' &&
              typeof variableData !== 'number'
            ) {
              if (variableData.readonly) variableNameLabel = `${variableName}${_tt('(Read-Only)')}`;
            }
            acc.push([variableNameLabel, variableName]);
            return acc;
          }, []);
          return dropdownVariables;
        };
      }
      this.jsonInit({
        kaiPythonFunctionName: ['get_classroom_variable'],
        blocklyType: 'get_classroom_variable',
        message0: _tt('Get the value of Classroom variable %1'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'NAME',
            options: generateDropdown,
          },
        ],
        output: 'any',
      });
      this.setColour(COLOR_CONTROL);
    },
  };
  Blockly.Blocks.getConfig = Blockly.Blocks.get_classroom_variable;

  Blockly.Blocks.set_classroom_variable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.set_classroom_variable']);
      const hasVariables =
        classRoomStore.globalVariables &&
        Object.keys(classRoomStore.globalVariables).length > 0;
      let generateDropdown = [['none', '']];
      if (hasVariables) {
        generateDropdown = () => {
          const dropdownVariables = Object.entries(classRoomStore.globalVariables).reduce((acc, currPair) => {
            const [variableName, variableData] = currPair;
            if (
              typeof variableName !== 'string' &&
              typeof variableName !== 'number'
            ) return acc; // reject wrong data
            let variableNameLabel = variableName;
            if (
              !!variableData &&
              typeof variableData !== 'string' &&
              typeof variableData !== 'number'
            ) {
              if (variableData.readonly) {
                variableNameLabel = `${variableNameLabel}${_tt('(Student Read-Only)')}`;
                if (!userStore.isTeacher) return acc;
              }
            }
            acc.push([variableNameLabel, variableName]);
            return acc;
          }, []);
          return dropdownVariables;
        };
      } else {
        this.setWarningText(_tt('no variable in the classroom!'));
      }
      this.jsonInit({
        kaiPythonFunctionName: ['set_classroom_variable'],
        blocklyType: 'set_classroom_variable',
        message0: _tt('Set Classroom variable %1 as %2'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'NAME',
            options: generateDropdown,
          },
          {
            type: 'input_value',
            name: 'VALUE',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_CONTROL);
    },
  };
  Blockly.Blocks.setConfig = Blockly.Blocks.set_classroom_variable;

  /*
  Object.values(sensorSpecs)
    .filter(
      sensor =>
        sensor.mode === "continuous" &&
        (!sensor.dataKeys || sensor.dataKeys.length === 1)
    )
    .forEach(sensor => {
      let type = "Number";
      if (sensor.type === "boolean") type = "Boolean";
      if (
        sensor.varName !== "gripper" &&
        sensor.varName !== "ultrasonic_distance_sensor" &&
        // sensor.varName !== 'temperature_sensor' &&
        sensor.varName !== "Waterproof_Temperature_Sensor" &&
        sensor.varName !== "relay" &&
        sensor.varName !== "humidity_sensor" &&
        sensor.varName !== "Sound_Sensor" &&
        sensor.varName !== "Light_Sensor" &&
        sensor.varName !== "UV_Sensor" &&
        sensor.varName !== "Moisture_Sensor" &&
        sensor.varName !== "Water_Sensor" &&
        sensor.varName !== "PH_Sensor" &&
        sensor.varName !== "Touch_Sensor" &&
        sensor.varName !== "Switch" &&
        sensor.varName !== "Pulse_Sensor" &&
        sensor.varName !== "BMP180_Barometer" &&
        sensor.varName !== "Linear_Potentiometer" &&
        sensor.varName !== "Rotary_Angle_Sensor" &&
        sensor.varName !== "ir_reflective_sensor" &&
        sensor.varName !== "human_body_ir_sensor" &&
        sensor.varName !== "Laser_Ranging_Sensor"
      ) {
        Blockly.Blocks[`sensing__${sensor.varName}`] = {
          init() {
            this.jsonInit({
              message0: `Bot %1 %2 🔌Add-on ${sensor.name}`,
              args0: [
                robotArgBySensor(this, sensor.id),
                {
                  type: "field_label",
                  text: "read",
                  class: "blocklyFlyoutLabelText"
                }
              ],
              output: type
            });
            const blocklyColor = sensor.blocklyColor || COLOR_SENSING;
            this.setColour(blocklyColor);
          }
        };
      }
    });
    */
  /*
   * define blockly from here, order by advanced toolbox
   */
  Blockly.Blocks.runProgram = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.runProgram']);
      this.jsonInit({
        message0: `${_tt('Run')} %1`,
        args0: [
          {
            type: 'input_statement',
            name: 'SETUP',
            check: 'any',
          },
        ],
        message1: `${_tt('Loop')} %1 %2`,
        args1: [
          {
            type: 'field_image',
            src: IMAGE_SRC_LOOP,
            width: 20,
            height: 20,
          },
          {
            type: 'input_statement',
            name: 'LOOP',
            check: 'any',
          },
        ],
        message2: `${_tt('Events')} %1`,
        args2: [
          {
            type: 'input_statement',
            name: 'EVENTS',
            check: 'on_event',
          },
        ],
        disabled: false,
        deletable: false,
      });
      this.setColour(COLOR_CONTROL);
    },
  };
  /*
   * PART 1-1: motion --> basic
   */
  Blockly.Blocks.motion_move__set_gear = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__set_gear']);
      this.jsonInit({
        message0: _tt('Bot %1 set speed to %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'GEAR',
            options: [
              [_tt('slow'), '10'],
              [_tt('normal'), '8'],
              [_tt('fast'), '6'],
              [_tt('fastest'), '4'],
            ],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to move forward in CM
   */
  Blockly.Blocks.motion_move__move_forwards_distance = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__move_forwards_distance']);
      this.jsonInit({
        message0: _tt('Bot %1 move forward %2 cm'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'AMOUNT',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to move backward in CM
   */
  Blockly.Blocks.motion_move__move_backwards_distance = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__move_backwards_distance']);
      this.jsonInit({
        message0: _tt('Bot %1 move backward %2 cm'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'AMOUNT',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to turn left by degree
   */
  Blockly.Blocks.motion_angle__turn_left = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_angle__turn_left']);
      this.jsonInit({
        message0: _tt('Bot %1 turn left by %2 degrees'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'ANGLE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to turn right by degree
   */
  Blockly.Blocks.motion_angle__turn_right = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_angle__turn_right']);
      this.jsonInit({
        message0: _tt('Bot %1 turn right by %2 degrees'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'ANGLE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  /*
   * PART 1-2: motion --> destination
   * Send JSON command to robot to turn to a traget degree
   */
  Blockly.Blocks.motion_angle__change_to = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_angle__change_to']);
      this.jsonInit({
        message0: _tt('Bot %1 set angle to %2 degrees'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'ANGLE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to move to position by target position
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.motion_move__move_to_position_obj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__move_to_position_obj']);
      this.jsonInit({
        message0: _tt('Bot %1 move to %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to move to position by target position, but stop at a distance before arrive
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.motion_move__stopXYObjWithDistance = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__stopXYObjWithDistance']);
      this.jsonInit({
        message0: _tt('Bot %1 move to %2, stop %3 cm away'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
          {
            type: 'input_value',
            name: 'DISTANCE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * generate position object by input X and Y
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.sensing__targetXYObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__targetXYObj']);
      this.jsonInit({
        message0: _tt('%1 position X: %2 Y: %3 cm'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_POSITION,
            width: 20,
            height: 20,
          },
          {
            type: 'input_value',
            name: 'POSITION_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'POSITION_Y',
            check: 'Number',
          },
        ],
        output: 'obj_position',
      });
      this.setColour(COLOR_POSITION);
    },
  };
  /**
   * generate position object by reading a robot's X and Y
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.sensing__robotXYAObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__robotXYAObj']);
      this.jsonInit({
        message0: _tt('%1 position of Bot %2'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_POSITION,
            width: 20,
            height: 20,
          },
          robotArg(this),
        ],
        output: 'obj_position',
      });
      this.setColour(COLOR_POSITION);
    },
  };
  /**
   * generate position object by reading map mark's X and Y on mat
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.sensing__mapMarkXYObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__mapMarkXYObj']);
      this.jsonInit({
        message0: _tt('%1 position of map mark'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_POSITION,
            width: 20,
            height: 20,
          },
        ],
        output: 'obj_position',
      });
      this.setColour(COLOR_POSITION);
    },
  };
  /**
   * calculate distance between position A and position B
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.sensing__distanceOfPositionXYObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__distanceOfPositionXYObj']);
      this.jsonInit({
        message0: _tt('distance (cm) between %1 and %2'),
        args0: [
          {
            type: 'input_value',
            name: 'POSITION_XY_A',
            check: 'obj_position',
          },
          {
            type: 'input_value',
            name: 'POSITION_XY_B',
            check: 'obj_position',
          },
        ],
        inputsInline: true,
        output: 'Number',
      });
      this.setColour(COLOR_POSITION);
    },
  };
  Blockly.Blocks.sensing__positionXYObjOutBoundary = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__positionXYObjOutBoundary']);
      this.jsonInit({
        message0: _tt('%1 is out of mat boundary'),
        args0: [
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
        ],
        inputsInline: true,
        output: 'Number',
      });
      this.setColour(COLOR_POSITION);
    },
  };
  /**
   * PART 1-3: motion --> pathfinding
   * Send JSON command to robot to find a path to target position by drop-down list
   */
  Blockly.Blocks.motion_move__go_to_place = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__go_to_place']);
      this.jsonInit({
        message0: _tt('Bot %1 navigate to %2'),
        args0: [robotArgByRole(this), placesArg()],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to find a path to target position by a text name
   */
  Blockly.Blocks.motion_move__go_to_place_with_input_name = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__go_to_place_with_input_name']);
      this.jsonInit({
        message0: _tt('Bot %1 navigate to %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_input',
            name: 'PLACE_NAME',
            text: 'center point',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to find a path to target position
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.motion_move__go_to_XYPosition_by_the_pathfinding = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__go_to_XYPosition_by_the_pathfinding']);
      this.jsonInit({
        message0: _tt('Bot %1 navigate to %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * PART 1-4: motion --> position adjustment
   * Send JSON command to robot to move to a target position accurately with multiple step adjustment
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.motion_move__move_to_XY_obj_with_self_adjustment = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__move_to_XY_obj_with_self_adjustment']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 move to %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('accurately'),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to move to a target position accurately with multiple step adjustment, but stop at a distance before arrive
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.motion_move__move_to_XY_obj_stop_distance_with_self_adjustment = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__move_to_XY_obj_stop_distance_with_self_adjustment']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 move to %3, stop at distance %4 cm'),
        args0: [
          robotArgByRole(this),
          getStrongText('accurately'),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
          {
            type: 'input_value',
            name: 'DISTANCE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  /**
   * PART 1-5: motion --> interaction
   * Send JSON command to robot to move to a target position accurately, stop at the position where the gripper can just reach the object
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.motion_move__grabObjAtXY = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__grabObjAtXY']);
      this.jsonInit({
        message0: _tt('Bot %1 grab object at %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to move to a target position accurately, stop at the position where the gripper can just drop the object
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.motion_move__releaseObjAtXY = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__releaseObjAtXY']);
      this.jsonInit({
        message0: _tt('Bot %1 release object at %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to move to a target position then go by a distance
   * @object position {'targetXY': {objType: 'target_XY', objValueX: X, objValueY: Y}}
   */
  Blockly.Blocks.motion_follow__stopXYObjWithDistance = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_follow__stopXYObjWithDistance']);
      this.jsonInit({
        message0: _tt('Bot %1 follow %2, go %3 cm'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
          {
            type: 'input_value',
            name: 'DISTANCE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  /**
   * PART 1-6: motion --> special
   * Send JSON command to robot to stop immediately, this is usually triggered by event
   */
  Blockly.Blocks.motion_move__stop = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__stop']);
      this.jsonInit({
        message0: _tt('Bot %1 stop moving (Event)'),
        args0: [robotArgByRole(this)],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to move a circle by center angle
   */
  Blockly.Blocks.motion_special__circle = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_special__circle']);
      this.jsonInit({
        message0:
          _tt('Bot %1 drive %2 in %3 circle, central angles %4°'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'LEFT_RIGHT',
            options: [[_tt('counterclockwise'), '1'], [_tt('clockwise '), '2']],
          },
          {
            type: 'field_dropdown',
            name: 'DIAMETER',
            options: [
              ['small', '1'],
              ['medium', '2'],
              ['large', '3'],
            ],
          },
          {
            type: 'input_value',
            name: 'ANGLE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to make a U-turn
   */
  Blockly.Blocks.motion_special__u_turn = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_special__u_turn']);
      this.jsonInit({
        message0:
          _tt('Bot %1 %2 by %3 U-turn with angles %4°'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'DIRECTION',
            options: [[_tt('drive'), '1'], [_tt('reverse'), '2']],
          },
          {
            type: 'field_dropdown',
            name: 'ROTATION',
            options: [[_tt('left'), '1'], [_tt('right'), '2']],
          },
          {
            type: 'input_value',
            name: 'ANGLE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * Send JSON command to robot to make a U-turn
   */
  Blockly.Blocks.motion_special__free_move = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_special__free_move']);
      this.jsonInit({
        message0:
          _tt('Bot %1 set【left wheel direction %2 speed %3 ∕ right wheel direction %4 speed %5】by %6 Second(s)'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'LEFT_DIR',
            options: [[_tt('forward'), '1'], [_tt('backward'), '2']],
          },
          {
            type: 'field_dropdown',
            name: 'LEFT_SPEED',
            options: [[_tt('fastest'), '4'], [_tt('fast'), '6'], [_tt('normal'), '8'], [_tt('slow'), '10']],
          },
          {
            type: 'field_dropdown',
            name: 'RIGHT_DIR',
            options: [[_tt('forward'), '1'], [_tt('backward'), '2']],
          },
          {
            type: 'field_dropdown',
            name: 'RIGHT_SPEED',
            options: [[_tt('fastest'), '4'], [_tt('fast'), '6'], [_tt('normal'), '8'], [_tt('slow'), '10']],
          },
          {
            type: 'input_value',
            name: 'TIME',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * PART 2-1: bits --> on-board
   * Send JSON command to robot to open gripper
   * @sensor Gripper (on-board), command only takes effect after sensor are configured
   */
  Blockly.Blocks.motion_servo__open_close_toggle = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_servo__open_close_toggle']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 ⛵ Gripper open-status %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'OPEN_CLOSE',
            check: 'Boolean',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_ONBOARD_GRIPPER);
    },
  };
  /**
   * Read gripper status (Boolean) from real-time robot sensor update variables
   * @sensor Gripper (on-board), command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__gripper = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__gripper']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 ⛵ Gripper open-status (true/false)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ONBOARD_GRIPPER);
    },
  };
  /**
   * Read ultrasonic sensor value (mm) from real-time robot sensor update variables
   * @sensor Ultrasonic Sensor (on-board), command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__ultrasonic_distance_sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__ultrasonic_distance_sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 ⛵ Ultrasonic Sensor distance (mm)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ONBOARD_ULTRASONIC);
    },
  };
  /**
   * Send JSON command to robot to beep the on-board buzzer
   * @sensor Buzzer (on-board), always enabled
   * @object {music: {objType: 'sound_RTTTLList', index: 1, cmd: "Don't Care:d=16,o=5,b=125:f,e,f", frequency: 1000, duration: 500}}
   */
  Blockly.Blocks.sound_board_buzzer_play__sound = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sound_board_buzzer_play__sound']);
      this.jsonInit({
        message0: _tt('Bot %1 ⛵ Buzzer %2 %3 at %4 %% volume'),
        args0: [
          robotArgByRole(this),
          getStrongText('play'),
          {
            type: 'input_value',
            name: 'MUSIC',
            check: 'obj_sound',
          },
          {
            type: 'input_value',
            name: 'VOLUME',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SOUND);
    },
  };
  /**
   * Send JSON command to robot to light headlight by color
   * @sensor Headlights (on-board), always enabled
   * @object {color: {objType: 'color_RGB', r: 255, g: 0, b: 0}}
   */
  Blockly.Blocks.leddiffuser_set_colorObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.leddiffuser_set_colorObj']);
      this.jsonInit({
        type: 'leddiffuser_set_colorObj',
        message0: _tt('Bot %1 %2 ⛵ %3 Headlight(s) to %4'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'field_dropdown',
            name: 'HEADLIGHT',
            options: [[_tt('Left'), '1'], [_tt('Right'), '2'], [_tt('Both'), '3']],
          },
          {
            type: 'input_value',
            name: 'COLOR',
            check: ['obj_color', 'obj_position'],
          },
        ],
        inputsInline: true,
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '#5EC3D6',
      });
    },
  };
  /**
   * Send JSON command to robot to flash headlight
   * @sensor Headlights (on-board), always enabled
   */
  Blockly.Blocks.leddiffuser_blink = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.leddiffuser_blink']);
      this.jsonInit({
        type: 'leddiffuser_blink',
        message0:
          _tt('Bot %1 %2 ⛵ Headlights blink every %3 mS, brightness %4 %%'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'PERIOD_MS',
          },
          {
            type: 'input_value',
            name: 'BRIGHTNESS',
            check: 'Number',
          },
        ],
        inputsInline: true,
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '#5EC3D6',
      });
    },
  };
  /**
   * Send JSON command to robot to swap color when flashing headlight
   * @sensor Headlights (on-board), always enabled
   */
  Blockly.Blocks.leddiffuser_blink_swap = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.leddiffuser_blink_swap']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 ⛵ Headlights swap color %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'YES_NO',
            check: 'Boolean',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
        colour: '#5EC3D6',
      });
    },
  };
  /**
   * PART 2-2: bits --> sound
   * Send JSON command to robot to beep an external buzzer
   * @sensor Buzzer, command only takes effect after sensor are configured
   * @object {music: {objType: 'sound_RTTTLList', index: 1, cmd: "Don't Care:d=16,o=5,b=125:f,e,f", frequency: 1000, duration: 500}}
   */
  Blockly.Blocks.sound_ext_buzzer_play__sound = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sound_ext_buzzer_play__sound']);
      this.jsonInit({
        message0: _tt('Bot %1 🔌Add-on Buzzer %2 %3 at %4 %% volume'),
        args0: [
          robotArgByRole(this),
          getStrongText('play'),
          {
            type: 'input_value',
            name: 'MUSIC',
            check: 'obj_sound',
          },
          {
            type: 'input_value',
            name: 'VOLUME',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SOUND);
    },
  };
  /**
   * generate sound object by drop-down list
   * @object {music: {objType: 'sound_RTTTLList', index: 1, cmd: "Don't Care:d=16,o=5,b=125:f,e,f", frequency: 1000, duration: 500}}
   */
  Blockly.Blocks.sensing__soundRTTTLListObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__soundRTTTLListObj']);
      this.jsonInit({
        message0: _tt('%1 Song %2'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_SOUND,
            width: 20,
            height: 20,
          },
          {
            type: 'field_dropdown',
            name: 'LIST',
            options: RTTTL_SONGS,
          },
        ],
        output: 'obj_sound',
        inputsInline: true,
      });
      this.setColour(COLOR_SOUND);
    },
  };
  /**
   * generate sound object by raw RTTTL command
   * @object {music: {objType: 'sound_RTTTLList', index: 1, cmd: "Don't Care:d=16,o=5,b=125:f,e,f", frequency: 1000, duration: 500}}
   */
  Blockly.Blocks.sensing__soundRTTTLCommandObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__soundRTTTLCommandObj']);
      this.jsonInit({
        message0: _tt('%1 RTTTL %2 %3'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_SOUND,
            width: 20,
            height: 20,
          },
          {
            type: 'input_dummy',
          },
          {
            type: 'field_input',
            name: 'COMMAND',
            text:
              'Five for Fighting Superman:d=32,o=6,b=25:c#,c#,d#,f,8g#,c#,c#,d#,16f,8g#,a#5,16c#,16f#,16f,16c#,a#5,f#,f,8c#',
          },
        ],
        output: 'obj_sound',
        inputsInline: false,
        helpUrl:
          'http://mines.lumpylumpy.com/Electronics/Computers/Software/Cpp/MFC/RingTones.RTTTL',
      });
      this.setColour(COLOR_SOUND);
    },
    onchange() {
      const cmd = this.getFieldValue('COMMAND');
      if (String(cmd).length > 255) {
        const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__soundRTTTLCommandObj']);
        this.setWarningText(_tt('RTTTL rhythm is too long !'));
        this.setColour(COLOR_WARNING);
      } else {
        this.setWarningText(null);
        this.setColour(COLOR_SOUND);
      }
    },
  };
  /**
   * generate sound object by frequency and duration
   * @object {music: {objType: 'sound_RTTTLList', index: 1, cmd: "Don't Care:d=16,o=5,b=125:f,e,f", frequency: 1000, duration: 500}}
   */
  Blockly.Blocks.sensing__soundBeepObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__soundBeepObj']);
      this.jsonInit({
        message0: _tt('%1 Buzz, frequency %2 Hz, duration %3 ms'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_SOUND,
            width: 20,
            height: 20,
          },
          {
            type: 'input_value',
            name: 'FREQUENCY',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'DURATION',
            check: 'Number',
          },
        ],
        output: 'obj_sound',
        inputsInline: true,
      });
      this.setColour(COLOR_SOUND);
    },
  };
  /**
   * read sound level (%) from real-time robot sensor update variables
   * @sensor Sound Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Sound_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Sound_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Sound Sensor sound level (%)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_SOUND);
    },
  };

  /**
   * PART 2-3: bits --> sight
   * generate color object by color picker
   * @object {color: {objType: 'color_RGB', r: 255, g: 0, b: 0}}
   */
  Blockly.Blocks.sensing__colorPickerObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__colorPickerObj']);
      this.jsonInit({
        message0: _tt('%1 color %2'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_RGB,
            width: 20,
            height: 20,
          },
          {
            type: 'field_colour',
            name: 'COLOUR',
            colour: '#ff0000',
          },
        ],
        output: 'obj_color',
      });
      this.setColour(COLOR_SIGHT_INPUT);
      this.getField('COLOUR')
        .setColours([
          '#000000',
          '#ffffff',
          '#ff0000',
          '#00ff00',
          '#0000ff',
          '#ffff00',
          '#ff00ff',
          '#00ffff',
          '#ff003f',
        ])
        .setColumns(3);
    },
  };
  /**
   * generate color object by color RGB value
   * @object {color: {objType: 'color_RGB', r: 255, g: 0, b: 0}}
   */
  Blockly.Blocks.sensing__colorRGBObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__colorRGBObj']);
      this.jsonInit({
        message0: _tt('%1 color Red %2 Green %3 Blue %4'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_RGB,
            width: 20,
            height: 20,
          },
          {
            type: 'input_value',
            name: 'R',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'G',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'B',
            check: 'Number',
          },
        ],
        output: 'obj_color',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };
  /**
   * read color from real-time robot sensor update variables and generate color object
   * @object {color: {objType: 'color_RGB', r: 255, g: 0, b: 0}}
   * @sensor Color Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Color_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Color_Sensor']);
      this.jsonInit({
        message0: _tt('%1 Bot %2 %3 🔌Add-on Color Sensor'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_RGB,
            width: 20,
            height: 20,
          },
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        inputsInline: true,
        output: 'obj_color',
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };
  /**
   * Send JSON command to robot to light an external single LED
   * @sensor Single LED (including Bright LED and LED), command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_white__adjust_brightness = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_white__adjust_brightness']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Single LED brightness to %3 %%'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'BRIGHTNESS',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to blink an external single LED
   * @sensor Single LED (including Bright LED and LED), command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_white__blink = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_white__blink']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Single LED blink every %3 mS'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'FREQUENCY',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * read brightness value (%) from real-time robot sensor update variables
   * @sensor Single LED (including Bright LED and LED), command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Bright_LED = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Bright_LED']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Single LED brightness (%%)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        inputsInline: true,
        output: 'Number',
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };
  /**
   * Send JSON command to robot to light an external RGB-LED, change all color
   * @sensor RGB-LED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_strip__adjust_all_color = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip__adjust_all_color']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on RGB-LED color at all positions to %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'COLOR',
            check: 'obj_color',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external RGB-LED, change one LED unit color by index
   * @sensor RGB-LED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_strip__adjust_index_color = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip__adjust_index_color']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on RGB-LED color at position %3 to %4'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'INDEX',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'COLOR',
            check: 'obj_color',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external RGB-LED, change all brightness
   * @sensor RGB-LED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_strip__adjust_all_brightness = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip__adjust_all_brightness']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on RGB-LED all lights brightness to %3 %%'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'BRIGHTNESS',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external RGB-LED, change one LED unit brightness by index
   * @sensor RGB-LED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_strip__adjust_index_brightness = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip__adjust_index_brightness']);
      this.jsonInit({
        message0:
          _tt('Bot %1 %2 🔌Add-on RGB-LED light at position %3 , brightness to %4 %%'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'INDEX',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'BRIGHTNESS',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external RGB-LED, set animation with different mode
   * @sensor RGB-LED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_strip__light_mode = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip__light_mode']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on RGB-LED %3, animate every %4 mS'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'field_dropdown',
            name: 'MODE',
            options: [
              [_tt('right scroll'), '2'],
              [_tt('left scroll'), '3'],
              [_tt('mirror flip'), '4'],
              [_tt('on/off blink'), '5'],
            ],
          },
          {
            type: 'input_value',
            name: 'FREQUENCY',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external RGB-LED, reset to default color and brightness
   * @sensor RGB-LED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_strip__reset = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip__reset']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on RGB-LED to default'),
        args0: [
          robotArgByRole(this),
          getStrongText('reset'),
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * read color from real-time robot sensor update variables and generate color object
   * @object {color: {objType: 'color_RGB', r: 255, g: 0, b: 0}}
   * @sensor RGB-LED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__led_strip__read_rgb_by_index_number = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__led_strip__read_rgb_by_index_number']);
      this.jsonInit({
        message0: _tt('%1 Bot %2 %3 🔌Add-on RGB-LED color at position %4'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_RGB,
            width: 20,
            height: 20,
          },
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
          {
            type: 'input_value',
            name: 'INDEX',
            check: 'Number',
          },
        ],
        inputsInline: true,
        output: 'obj_color',
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };
  /**
   * Send JSON command to robot to light an external 4-Digi Display, by 4 numbers (each 0~9)
   * @sensor 4-Digi Display, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_4digi_tube__display_all_4digi = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_4digi_tube__display_all_4digi']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on 4-Digit Display to %3 %4 : %5 %6'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'A',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'B',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'C',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'D',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 4-Digi Display, set 1 numbers (each 0~9) by index
   * @sensor 4-Digi Display, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_4digi_tube__display_index_4digi = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_4digi_tube__display_index_4digi']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on 4-Digit Display number at position %3 to %4'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'INDEX',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'DIGI',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 4-Digi Display, set to time MM:SS layout with 2 numbers
   * @sensor 4-Digi Display, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_4digi_tube__display_time = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_4digi_tube__display_time']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on 4-Digit Display to MM:SS %3 : %4'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'MINUTES',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'SECONDS',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 4-Digi Display, set to time MM:SS layout with 2 numbers, start countdown
   * @sensor 4-Digi Display, command only takes effect after sensor are configured
   * will trigger event after countdown to 00:00 @event
   */
  Blockly.Blocks.sight_4digi_tube__display_time_countdown = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_4digi_tube__display_time_countdown']);
      this.jsonInit({
        message0:
          _tt('Bot %1 %2 🔌Add-on 4-Digit Display to MM %3 : SS %4 and start to countdown ⏰'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'MINUTES',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'SECONDS',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 4-Digi Display, set a bit on/off by index
   * @sensor 4-Digi Display, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_4digi_tube__enable_index = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_4digi_tube__enable_index']);
      this.jsonInit({
        message0:
          _tt('Bot %1 %2 🔌Add-on 4-Digit Display enable-status at position %3 to %4'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'INDEX',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'ENABLE',
            check: 'Boolean',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 4-Digi Display, change display brightness
   * @sensor 4-Digi Display, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_4digi_tube__set_brightness = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_4digi_tube__set_brightness']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on 4-Digit Display brightness to %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'field_dropdown',
            name: 'LIST',
            options: [['10%', '10'], ['50%', '50'], ['100%', '100']],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * read number (0~9) from real-time robot sensor update variables
   * @sensor 4-Digi Display, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__The_4_Digit_Display = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__The_4_Digit_Display']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on 4-Digit Display value at position %3'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
          {
            type: 'input_value',
            name: 'INDEX',
            check: 'Number',
          },
        ],
        output: 'Number',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };
  /**
   * Send JSON command to robot to light an external OLED with a string
   * @sensor OLED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_OLED_display__set_text = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_OLED_display__set_text']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on OLED screen display text %3 at line %4'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'TEXT',
            check: 'String',
          },
          {
            type: 'field_dropdown',
            name: 'LINE',
            options: [['1', '1'], ['2', '2'], ['3', '3'], ['4', '4']],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external OLED with a number 0~9999
   * @sensor OLED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_OLED_display__set_number = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_OLED_display__set_number']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on OLED screen display number %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'NUMBER',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external OLED with a predefined icon
   * @sensor OLED, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_OLED_display__set_icon = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_OLED_display__set_icon']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on OLED screen display icon %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'field_dropdown',
            name: 'ICON',
            options: [['KAI', '1'], ['chat', '2'], ['cancel', '3'], ['aliens', '4'], ['cool', '5'], ['error', '6'], ['rain', '7'], ['sun', '8']],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 8x8 LED matrix with a 8x8 matrix object
   * @sensor 8x8 LED Matrix, command only takes effect after sensor are configured
   * @object {matrix_8_8: [0, 0, 0, 0, 0, 0, 0, 0]}
   */
  Blockly.Blocks.sight_led_matrix_display__show = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_matrix_display__show']);
      this.jsonInit({
        // message0: 'Bot %1 external %2 LED MATRIX ⇨ display symbol %3 with oritation %4',
        message0: _tt('Bot %1 %2 🔌Add-on LED Matrix display symbol %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'PIXELS',
            check: 'obj_matrix_8_8',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 8x8 LED matrix with a string, will keep scrolling until next command
   * @sensor 8x8 LED Matrix, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_matrix_display__set_text = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_matrix_display__set_text']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on LED Matrix display text %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'TEXT',
            check: 'String',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 8x8 LED matrix, simulate a progress bar
   * @sensor 8x8 LED Matrix, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_matrix_display__set_progress = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_matrix_display__set_progress']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on LED Matrix, to display progress bar of %3 %%'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'PROGRESS',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * Send JSON command to robot to light an external 8x8 LED matrix, set display brightness
   * @sensor 8x8 LED Matrix, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sight_led_matrix_display__set_brightness = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_matrix_display__set_brightness']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on LED Matrix brightness to %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'field_dropdown',
            name: 'LIST',
            options: [['100%', '100'], ['50%', '50'], ['10%', '10']],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * read 8x8 LED matrix value from real-time robot sensor update variables and generate 8x8 matrix object
   * @sensor 8x8 LED Matrix, command only takes effect after sensor are configured
   * @object {matrix_8_8: [0, 0, 0, 0, 0, 0, 0, 0]}
   */
  Blockly.Blocks.sensing__led_matrix_display = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__led_matrix_display']);
      this.jsonInit({
        message0: _tt('░ Bot %1 %2 🔌Add-on LED Matrix pixels'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        inputsInline: true,
        output: 'obj_matrix_8_8',
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };
  /**
   * generate 8x8 matrix object by drop down list
   * @object {matrix_8_8: [0, 0, 0, 0, 0, 0, 0, 0]}
   */
  Blockly.Blocks.sensing__led_matrix_display_constant = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__led_matrix_display_constant']);
      this.jsonInit({
        message0: _tt('░ 8x8 matrix of %1'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'LIST',
            options: MATRIX_8_8_LIST,
          },
        ],
        output: 'obj_matrix_8_8',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };
  /**
   * generate 8x8 matrix object by 8x8 check
   * @object {matrix_8_8: [0, 0, 0, 0, 0, 0, 0, 0]}
   */
  Blockly.Blocks.sensing__led_matrix_display_pixels = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__led_matrix_display_pixels']);
      this.jsonInit({
        message0:
          `${_tt('░ LED matrix pixels:')} %1 %2 %3 %4 %5 %6 %7 %8 %9 %10 %11 %12 %13 %14 %15 %16 %17 %18 %19 %20 %21 %22 %23 %24 %25 %26 %27 %28 %29 %30 %31 %32 %33 %34 %35 %36 %37 %38 %39 %40 %41 %42 %43 %44 %45 %46 %47 %48 %49 %50 %51 %52 %53 %54 %55 %56 %57 %58 %59 %60 %61 %62 %63 %64 %65 %66 %67 %68 %69 %70 %71 %72`,
        args0: [
          { type: 'input_dummy' },
          { type: 'field_checkbox', name: 'C00', checked: false },
          { type: 'field_checkbox', name: 'C01', checked: false },
          { type: 'field_checkbox', name: 'C02', checked: false },
          { type: 'field_checkbox', name: 'C03', checked: false },
          { type: 'field_checkbox', name: 'C04', checked: false },
          { type: 'field_checkbox', name: 'C05', checked: false },
          { type: 'field_checkbox', name: 'C06', checked: false },
          { type: 'field_checkbox', name: 'C07', checked: false },
          { type: 'input_dummy' },
          { type: 'field_checkbox', name: 'C10', checked: false },
          { type: 'field_checkbox', name: 'C11', checked: false },
          { type: 'field_checkbox', name: 'C12', checked: false },
          { type: 'field_checkbox', name: 'C13', checked: false },
          { type: 'field_checkbox', name: 'C14', checked: false },
          { type: 'field_checkbox', name: 'C15', checked: false },
          { type: 'field_checkbox', name: 'C16', checked: false },
          { type: 'field_checkbox', name: 'C17', checked: false },
          { type: 'input_dummy' },
          { type: 'field_checkbox', name: 'C20', checked: false },
          { type: 'field_checkbox', name: 'C21', checked: false },
          { type: 'field_checkbox', name: 'C22', checked: false },
          { type: 'field_checkbox', name: 'C23', checked: false },
          { type: 'field_checkbox', name: 'C24', checked: false },
          { type: 'field_checkbox', name: 'C25', checked: false },
          { type: 'field_checkbox', name: 'C26', checked: false },
          { type: 'field_checkbox', name: 'C27', checked: false },
          { type: 'input_dummy' },
          { type: 'field_checkbox', name: 'C30', checked: false },
          { type: 'field_checkbox', name: 'C31', checked: false },
          { type: 'field_checkbox', name: 'C32', checked: false },
          { type: 'field_checkbox', name: 'C33', checked: false },
          { type: 'field_checkbox', name: 'C34', checked: false },
          { type: 'field_checkbox', name: 'C35', checked: false },
          { type: 'field_checkbox', name: 'C36', checked: false },
          { type: 'field_checkbox', name: 'C37', checked: false },
          { type: 'input_dummy' },
          { type: 'field_checkbox', name: 'C40', checked: false },
          { type: 'field_checkbox', name: 'C41', checked: false },
          { type: 'field_checkbox', name: 'C42', checked: false },
          { type: 'field_checkbox', name: 'C43', checked: false },
          { type: 'field_checkbox', name: 'C44', checked: false },
          { type: 'field_checkbox', name: 'C45', checked: false },
          { type: 'field_checkbox', name: 'C46', checked: false },
          { type: 'field_checkbox', name: 'C47', checked: false },
          { type: 'input_dummy' },
          { type: 'field_checkbox', name: 'C50', checked: false },
          { type: 'field_checkbox', name: 'C51', checked: false },
          { type: 'field_checkbox', name: 'C52', checked: false },
          { type: 'field_checkbox', name: 'C53', checked: false },
          { type: 'field_checkbox', name: 'C54', checked: false },
          { type: 'field_checkbox', name: 'C55', checked: false },
          { type: 'field_checkbox', name: 'C56', checked: false },
          { type: 'field_checkbox', name: 'C57', checked: false },
          { type: 'input_dummy' },
          { type: 'field_checkbox', name: 'C60', checked: false },
          { type: 'field_checkbox', name: 'C61', checked: false },
          { type: 'field_checkbox', name: 'C62', checked: false },
          { type: 'field_checkbox', name: 'C63', checked: false },
          { type: 'field_checkbox', name: 'C64', checked: false },
          { type: 'field_checkbox', name: 'C65', checked: false },
          { type: 'field_checkbox', name: 'C66', checked: false },
          { type: 'field_checkbox', name: 'C67', checked: false },
          { type: 'input_dummy' },
          { type: 'field_checkbox', name: 'C70', checked: false },
          { type: 'field_checkbox', name: 'C71', checked: false },
          { type: 'field_checkbox', name: 'C72', checked: false },
          { type: 'field_checkbox', name: 'C73', checked: false },
          { type: 'field_checkbox', name: 'C74', checked: false },
          { type: 'field_checkbox', name: 'C75', checked: false },
          { type: 'field_checkbox', name: 'C76', checked: false },
          { type: 'field_checkbox', name: 'C77', checked: false },
        ],
        output: 'obj_matrix_8_8',
        inputsInline: false,
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };

  /**
   * PART 2-4: bits --> environmental
   * read light sensor value (%) from real-time robot sensor update variables
   * @sensor Light Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Light_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Light_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Light Sensor (%)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * read temperature value (°C) or humidity value (%) from real-time robot sensor update variables
   * @sensor Temperature & Humidity Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__humidity_sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__humidity_sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Temperature & Humidity Sensor %3'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
          {
            type: 'field_dropdown',
            name: 'INDEX',
            options: [[_tt('Temperature (℃)'), '0'], [_tt('Humidity (%)'), '1']],
          },
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * read UV level (%) from real-time robot sensor update variables
   * @sensor UV Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__UV_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__UV_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on UV Sensor (%)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * read moisture level (%) from real-time robot sensor update variables
   * @sensor Moisture Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Moisture_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Moisture_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Moisture Sensor (%)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * read water wetness level (%) from real-time robot sensor update variables
   * @sensor Water Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Water_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Water_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Water Sensor (%)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * read temperature (℃) from real-time robot sensor update variables
   * @sensor Waterproof Temperature Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Waterproof_Temperature_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Waterproof_Temperature_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Waterproof Temperature Sensor (℃)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * read PH value from real-time robot sensor update variables
   * @sensor Moisture Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__PH_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__PH_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on PH Sensor (pH value)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * read BMP180 Barometer value from real-time robot sensor update variables
   * @sensor BMP180 Barometer, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__BMP180_Barometer = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__BMP180_Barometer']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on BMP180 Barometer (kPa)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * read air pressure (kPa) or humidity (%) or temperature (℃) from real-time robot sensor update variables
   * @sensor BME280 Atmospheric Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__BME280_Atmospheric_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__BME280_Atmospheric_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Atmospheric Sensor %3'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
          {
            type: 'field_dropdown',
            name: 'INDEX',
            options: [
              [_tt('air pressure(kPa)'), '0'],
              [_tt('humidity (%)'), '1'],
              [_tt('temperature (℃)'), '2'],
            ],
          },
        ],
        inputsInline: true,
        output: 'Number',
      });
      this.setColour(COLOR_ENVIRONMENTAL);
    },
  };
  /**
   * PART 2-5: bits --> action
   * Send JSON command to robot to light an external 8x8 LED matrix, set display brightness
   * @sensor IR Emitter, command only takes effect after sensor are configured
   */
  Blockly.Blocks.irTransmitter = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.irTransmitter']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on IR Emitter to send %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'COMMAND',
            check: 'ir_code',
          },
        ],
        inputsInline: true,
        nextStatement: 'any',
        previousStatement: 'any',
      });
      // this.setColour(COLOR_MOTION);
      this.setColour(COLOR_IR);
    },
  };
  /**
   * read IR receiver raw code (long int) from real-time robot sensor update variables
   * @sensor IR Receiver, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__irReceiver = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__irReceiver']);
      this.jsonInit({
        message0: _tt('📡 %1 %2 🔌Add-on IR Receiver lasted raw code'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'ir_code',
      });
      this.setColour(COLOR_IR);
    },
  };
  /**
   * generate IR raw code, it's a number
   */
  Blockly.Blocks.sensing__irRawCode = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__irRawCode']);
      this.jsonInit({
        message0: _tt('📡 IR remote raw code %1'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'CODE',
            options: IR_COMMANDS,
          },
        ],
        output: 'ir_code',
      });
      this.setColour(COLOR_IR);
    },
  };
  /**
   * Send JSON command to robot to control an external realy, set on/off
   * @sensor Relay, command only takes effect after sensor are configured
   */
  Blockly.Blocks.relaySwitch = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.relaySwitch']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Water Pump duty %3 %%, for %4 seconds'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'ON_OFF',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'DELAY',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read Relay (%) from real-time robot sensor update variables
   * @sensor Relay, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__relay = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__relay']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Relay duty (%%)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read Rotary Angle Sensor (%) from real-time robot sensor update variables
   * @sensor Rotary Angle Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Rotary_Angle_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Rotary_Angle_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Rotary Angle Sensor (degree)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read Linear Potentiometer (%) from real-time robot sensor update variables
   * @sensor Linear Potentiometer, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Linear_Potentiometer = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Linear_Potentiometer']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Linear Potentiometer (%)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * enable pulse sensor
   * @sensor Pulse Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.Sensor_Pulse_Sensor_enable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.Sensor_Pulse_Sensor_enable']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Pulse Sensor Detection'),
        args0: [
          robotArgByRole(this),
          getStrongText('start'),
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      // this.setColour(COLOR_MOTION);
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * reset Photo Electric Counter and start counting
   * @sensor Photo Electric Counter, command only takes effect after sensor are configured
   */
  Blockly.Blocks.Sensor_Photo_Electric_Counter_reset = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.Sensor_Photo_Electric_Counter_reset']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Photo Electric Counter'),
        args0: [
          robotArgByRole(this),
          getStrongText('reset'),
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      // this.setColour(COLOR_MOTION);
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read Photo Electric Counter number from real-time robot sensor update variables
   * @sensor Photo Electric Counter, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Photo_Electric_Counter = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Photo_Electric_Counter']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Photo Electric Counter'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read touch status true/false value from real-time robot sensor update variables
   * @sensor Touch Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Touch_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Touch_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Touch Sensor touch-status (true/false)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read pressed status true/false from real-time robot sensor update variables
   * @sensor Push Button, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Push_Button = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Push_Button']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Button pressed-status (true/false)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read push status true/false from real-time robot sensor update variables
   * @sensor Switch, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Switch = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Switch']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Switch on-status (true/false)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ACTION);
    },
  };

  /**
   * read IR Reflective Sensor detected-status true/false from real-time robot sensor update variables
   * @sensor IR Reflective Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__ir_reflective_sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__ir_reflective_sensor']);
      this.jsonInit({
        message0:
          _tt('Bot %1 %2 🔌Add-on IR Reflective Sensor detected-status (true/false)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read Collision Sensor closed-status true/false from real-time robot sensor update variables
   * @sensor Collision Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__limit_switch = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__limit_switch']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Collision Sensor closed-status (true/false)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read Tilt Switch tilt-status true/false from real-time robot sensor update variables
   * @sensor Tilt Switch, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__tilt_switch = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__tilt_switch']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Tilt Switch tilt-status (true/false)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read Pulse Sensor from real-time robot sensor update variables
   * @sensor Tilt Switch, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Pulse_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Pulse_Sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on Pulse Sensor heart beat rates (per min)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read PIR Motion Sensor active-status true/false from real-time robot sensor update variables
   * @sensor PIR Motion Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__human_body_ir_sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__human_body_ir_sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on PIR Motion Sensor active-status (true/false)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Boolean',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read Laser Ranging Sensor distance (mm) from real-time robot sensor update variables
   * @sensor Laser Ranging Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__Laser_Ranging_Sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__Laser_Ranging_Sensor']);
      this.jsonInit({
        message0: 'Bot %1 %2 🔌Add-on Laser Ranging Sensor distance (mm)',
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read 3-Axis Digital Compass angle (degree) from real-time robot sensor update variables
   * @sensor 3-Axis Digital Compass, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__read_3Axis_Digital_Compass_by_xyz = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__read_3Axis_Digital_Compass_by_xyz']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on 3-Axis Digital Compass %3 gauss'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
          {
            type: 'field_dropdown',
            name: 'XYZ',
            options: [['X', '0'], ['Y', '1'], ['Z', '2']],
          },
        ],
        inputsInline: true,
        output: 'Number',
      });
      this.setColour(COLOR_ACTION);
    },
  };
  /**
   * read MPU6050_Accelerometer and Gyro (degree) from real-time robot sensor update variables
   * @sensor MPU6050 Accelerometer & Gyro, command only takes effect after sensor are configured
   */
  Blockly.Blocks.sensing__MPU6050_Accelerometer_and_Gyro = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__MPU6050_Accelerometer_and_Gyro']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on MPU6050 Accelerometer & Gyro %3'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
          {
            type: 'field_dropdown',
            name: 'XYZ',
            options: [
              [_tt('X Acceleration'), '0'],
              [_tt('Y Acceleration'), '1'],
              [_tt('Z Acceleration'), '2'],
              [_tt('X Gravity'), '3'],
              [_tt('Y Gravity'), '4'],
              [_tt('Z Gravity'), '5'],
            ],
          },
        ],
        inputsInline: true,
        output: 'Number',
      });
      this.setColour(COLOR_ACTION);
    },
  };

  Blockly.Blocks.sensing__read_S100_microbit_last_message = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__read_S100_microbit_last_message']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 the last message from Micro:bit'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        inputsInline: true,
        output: 'String',
        colour: '%{BKY_TEXTS_HUE}',
      });
    },
  };
  /**
   * PART 3-1: events --> sensor event
   * set listening event from IR Receiver with IR-code
   * @sensor IR Receiver, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__irReceiver_Received = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__irReceiver_Received']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on IR Reciever triggered with IR-code %2'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          {
            type: 'input_value',
            name: 'COMMAND',
            check: 'ir_code',
          },
        ],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Touch Sensor touching
   * @sensor Touch Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__touch_sensor_touching = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__touch_sensor_touching']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Touch Sensor touching'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Button press-down
   * @sensor Button, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__button_pushed = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__button_pushed']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Button pressed'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Switch turn-on
   * @sensor Switch, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__switch_on = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__switch_on']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Switch on'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Switch turn-off
   * @sensor Switch, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__switch_off = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__switch_off']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Switch off'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from IR Reflective Sensor object detected
   * @sensor IR Reflective Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__ir_reflective_sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__ir_reflective_sensor']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on IR Reflective Sensor object detected'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Collision Sensor closed
   * @sensor Collision Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__limit_switch = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__limit_switch']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Collision Sensor closed'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from 4-digi Display countdown
   * @sensor 4-digi Display, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__4_digi_countdown = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__4_digi_countdown']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on 4-Digit Display countdown finished'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Tilt Switch tilt detected
   * @sensor Tilt Switch, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__tilt_detected = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__tilt_detected']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Tilt Switch tilt detected'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from PIR Motion Sensor active
   * @sensor PIR Motion Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__human_body_ir_sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__human_body_ir_sensor']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on PIR Motion Sensor active'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Hall Sensor active
   * @sensor Hall Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__magnetic_field_detected = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__magnetic_field_detected']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Magnetic - Hall Sensor active'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Vibration Sensor vibration detected
   * @sensor Vibration Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__vibration_detected = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__vibration_detected']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Vibration Sensor vibration detected'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Knock Sensor knock detected
   * @sensor Knock Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__knock_detected = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__knock_detected']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Vibration Sensor knock detected'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Pulse Sensor finished
   * @sensor Pulse Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__pulse_sensor_detected = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__pulse_sensor_detected']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Pulse Sensor detecting finished'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * set listening event from Gesture Sensor detected by different gestures
   * @sensor Gesture Sensor, command only takes effect after sensor are configured
   */
  Blockly.Blocks.events__gesture_detected = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__gesture_detected']);
      this.jsonInit({
        message0: _tt('On bot %1 🔌Add-on Gesture detected with gesture %2'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          {
            type: 'field_dropdown',
            name: 'COMMAND',
            options: GESTURES,
          },
        ],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };

  /**
   * PART 3-2: events --> system event
   * set listening event from robot just drive out of boundary
   */
  Blockly.Blocks.events__out_of_boundary = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__out_of_boundary']);
      this.jsonInit({
        message0: _tt('On bot %1 out of mat boundary'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };

  Blockly.Blocks.events__message_from_S100_microbit = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__message_from_S100_microbit']);
      this.jsonInit({
        message0: _tt('On receive message from Micro:bit %1'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * PART 4: timing
   * delay seconds, can be overrule by event
   */
  Blockly.Blocks.control__wait = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.control__wait']);
      this.jsonInit({
        message0: _tt('%1 wait %2 second(s)'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_WAIT,
            width: 20,
            height: 20,
          },
          {
            type: 'input_value',
            name: 'TIMEOUT',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_CONTROL);
    },
  };
  /**
   * read current time from browser
   */
  Blockly.Blocks.sensing__value_of_datetime = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__value_of_datetime']);
      this.jsonInit({
        message0: _tt('current %1'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'FORMAT',
            options: [
              [_tt('Year'), 'yyyy'],
              [_tt('Month'), 'MM'],
              [_tt('Day'), 'dd'],
              [_tt('Hour'), 'hh'],
              [_tt('Minute'), 'mm'],
              [_tt('Second'), 'ss'],
            ],
          },
        ],
        output: 'Number',
      });
      this.setColour(COLOR_SENSING);
    },
  };
  /**
   * read CPU time (second) from browser
   */
  Blockly.Blocks.sensing__current_second = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__current_second']);
      this.jsonInit({
        type: 'datetime_current_second',
        message0: _tt('current system time (seconds)'),
        output: 'Number',
      });
      this.setColour(COLOR_SENSING);
    },
  };
  /**
   * read CPU time (millisecond) from browser
   */
  Blockly.Blocks.sensing__current_millisecond = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__current_millisecond']);
      this.jsonInit({
        type: 'datetime_current_millisecond',
        message0: _tt('Current system time (milliseconds)'),
        output: 'Number',
      });
      this.setColour(COLOR_SENSING);
    },
  };
  /**
   * PART 5: print
   * print any variables to console
   */
  Blockly.Blocks.log = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.log']);
      this.jsonInit({
        type: 'log',
        message0: _tt('%1 print %2 to log'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_SRC_PRINT,
            width: 20,
            height: 20,
          },
          {
            type: 'input_value',
            name: 'CONTENT',
            // check: ['String', 'Number', 'Boolean'],
          },
        ],
        inputsInline: true,
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '#127AD4',
        tooltip: '',
        helpUrl: '',
      });
    },
  };

  Blockly.Blocks.send_chat = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sendChat']);
      this.jsonInit({
        type: 'log',
        message0: _tt('%1 Print %2 to chat everyone'),
        args0: [
          {
            type: 'field_image',
            src: IMAGE_CHAT_BUBBLE,
            width: 20,
            height: 20,
          },
          {
            type: 'input_value',
            name: 'CONTENT',
            // check: ['String', 'Number', 'Boolean'],
          },
        ],
        inputsInline: true,
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '#127AD4',
        tooltip: '',
        helpUrl: '',
      });
    },
  };
  /**
   * convert any variable to text
   */
  Blockly.Blocks.customized_logic_totext = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.customized_logic_totext']);
      this.jsonInit({
        type: 'customized_logic_totext',
        message0: _tt('%1 to Text'),
        args0: [
          {
            type: 'input_value',
            name: 'INPUT_VARIABLE',
          },
        ],
        inputsInline: true,
        output: 'String',
        colour: '%{BKY_TEXTS_HUE}',
      });
    },
  };
  /**
   * PART 6: logic
   * customized if
   */
  Blockly.Blocks.customized_controls_if = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.customized_controls_if']);
      this.jsonInit({
        type: 'customized_controls_if',
        message0: _tt('%{BKY_CONTROLS_IF_MSG_IF} %1'),
        args0: [
          {
            type: 'input_value',
            name: 'IF0',
            check: 'Boolean',
          },
        ],
        message1: _tt('%{BKY_CONTROLS_IF_MSG_THEN} %1'),
        args1: [
          {
            type: 'input_statement',
            name: 'DO0',
            check: 'any',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '%{BKY_LOGIC_HUE}',
        helpUrl: '%{BKY_CONTROLS_IF_HELPURL}',
        mutator: 'controls_if_mutator',
        extensions: ['controls_if_tooltip'],
      });
    },
  };
  /**
   * customized compare
   */
  Blockly.Blocks.customized_logic_compare = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.customized_logic_compare']);
      this.jsonInit({
        type: 'customized_logic_compare',
        message0: _tt('%1 %2 %3'),
        args0: [
          {
            type: 'input_value',
            name: 'A',
            // check: 'Number',
          },
          {
            type: 'field_dropdown',
            name: 'OP',
            options: [
              ['=', 'EQ'],
              ['\u2260', 'NEQ'],
              ['<', 'LT'],
              ['\u2264', 'LTE'],
              ['>', 'GT'],
              ['\u2265', 'GTE'],
            ],
          },
          {
            type: 'input_value',
            name: 'B',
            // check: 'Number',
          },
        ],
        inputsInline: !0,
        output: 'Boolean',
        colour: '%{BKY_LOGIC_HUE}',
        helpUrl: '%{BKY_LOGIC_COMPARE_HELPURL}',
        extensions: ['logic_compare', 'logic_op_tooltip'],
      });
    },
  };
  /**
   * compare object A and B if the contents are the same
   * @object obj_color
   */
  Blockly.Blocks.sensing__objCompare = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__objCompare']);
      this.jsonInit({
        message0: _tt('❔ object %1 equals to %2'),
        args0: [
          {
            type: 'input_value',
            name: 'OBJ_1',
            check: ['obj_color', 'obj_matrix_8_8'],
          },
          {
            type: 'input_value',
            name: 'OBJ_2',
            check: ['obj_color', 'obj_matrix_8_8'],
          },
        ],
        output: 'Boolean',
        inputsInline: true,
      });
      this.setColour(Blockly.Constants.Logic.HUE);
    },
  };
  /**
   * if a number is insode a range
   */
  Blockly.Blocks.output_logic__range = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.output_logic__range']);
      this.jsonInit({
        message0: _tt('is %1 %2 Min. %3 Max. %4'),
        args0: [
          {
            type: 'input_value',
            name: 'NUMBER',
            check: 'Number',
          },
          {
            type: 'field_dropdown',
            name: 'INOUT',
            options: [[_tt('inside'), 'INSIDE'], ['outside', 'OUTSIDE']],
          },
          {
            type: 'input_value',
            name: 'MIN',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'MAX',
            check: 'Number',
          },
        ],
        output: 'Boolean',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_LOGIC);
    },
  };
  /**
   * PART 7: loop
   * customized while until
   */
  Blockly.Blocks.customized_controls_whileUntil = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.customized_controls_whileUntil']);
      this.jsonInit({
        type: 'customized_controls_whileUntil',
        message0: '%1 %2',
        args0: [
          {
            type: 'field_dropdown',
            name: 'MODE',
            options: [
              ['%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_WHILE}', 'WHILE'],
              ['%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_UNTIL}', 'UNTIL'],
            ],
          },
          {
            type: 'input_value',
            name: 'BOOL',
            check: 'Boolean',
          },
        ],
        message1: '%{BKY_CONTROLS_REPEAT_INPUT_DO} %1',
        args1: [
          {
            type: 'input_statement',
            name: 'DO',
            check: 'any',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '%{BKY_LOOPS_HUE}',
        helpUrl: '%{BKY_CONTROLS_WHILEUNTIL_HELPURL}',
        extensions: ['controls_whileUntil_tooltip'],
      });
    },
  };
  /**
   * customized repeat
   */
  Blockly.Blocks.customized_controls_repeat_ext = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.customized_controls_repeat_ext']);
      this.jsonInit({
        type: 'customized_controls_repeat_ext',
        message0: '%{BKY_CONTROLS_REPEAT_TITLE}',
        args0: [
          {
            type: 'input_value',
            name: 'TIMES',
            check: 'Number',
          },
        ],
        message1: '%{BKY_CONTROLS_REPEAT_INPUT_DO} %1',
        args1: [
          {
            type: 'input_statement',
            name: 'DO',
            check: 'any',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '%{BKY_LOOPS_HUE}',
        tooltip: '%{BKY_CONTROLS_REPEAT_TOOLTIP}',
        helpUrl: '%{BKY_CONTROLS_REPEAT_HELPURL}',
      });
    },
  };
  /**
   * customized for loop
   */
  Blockly.Blocks.customized_controls_for = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.customized_controls_for']);
      this.jsonInit({
        type: 'customized_controls_for',
        message0: '%{BKY_CONTROLS_FOR_TITLE}',
        args0: [
          {
            type: 'field_variable',
            name: 'VAR',
            variable: null,
          },
          {
            type: 'input_value',
            name: 'FROM',
            check: 'Number',
            align: 'RIGHT',
          },
          {
            type: 'input_value',
            name: 'TO',
            check: 'Number',
            align: 'RIGHT',
          },
          {
            type: 'input_value',
            name: 'BY',
            check: 'Number',
            align: 'RIGHT',
          },
        ],
        message1: '%{BKY_CONTROLS_REPEAT_INPUT_DO} %1',
        args1: [
          {
            type: 'input_statement',
            name: 'DO',
            check: 'any',
          },
        ],
        inputsInline: !0,
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '%{BKY_LOOPS_HUE}',
        helpUrl: '%{BKY_CONTROLS_FOR_HELPURL}',
        extensions: ['contextMenu_newGetVariableBlock', 'controls_for_tooltip'],
      });
    },
  };
  /**
   * customized break
   */
  Blockly.Blocks.customized_controls_flow_statements = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.customized_controls_flow_statements']);
      this.jsonInit({
        type: 'customized_controls_flow_statements',
        message0: '%1',
        args0: [
          {
            type: 'field_dropdown',
            name: 'FLOW',
            options: [
              ['%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK}', 'BREAK'],
              ['%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE}', 'CONTINUE'],
            ],
          },
        ],
        previousStatement: 'any',
        colour: '%{BKY_LOOPS_HUE}',
        helpUrl: '%{BKY_CONTROLS_FLOW_STATEMENTS_HELPURL}',
        extensions: [
          'controls_flow_tooltip',
          'customized_controls_flow_in_loop_check',
        ],
      });
    },
  };
  /**
   * PART 9: math
   * get angle by angle picker
   */
  Blockly.Blocks.sensing__constant_angle = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__constant_angle']);
      this.jsonInit({
        message0: _tt('angle %1'),
        args0: [
          {
            type: 'field_angle',
            name: 'ANGLE',
            angle: 90,
          },
        ],
        output: 'Number',
        colour: '%{BKY_MATH_HUE}',
      });
    },
  };
  /**
   * convert a text to number
   */
  Blockly.Blocks.customized_logic_tonumber = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.customized_logic_tonumber']);
      this.jsonInit({
        type: 'customized_logic_tonumber',
        message0: _tt('%1 to Number'),
        args0: [
          {
            type: 'input_value',
            name: 'INPUT_VARIABLE',
            // check: 'String',
          },
        ],
        inputsInline: true,
        output: 'Number',
        colour: '%{BKY_LOGIC_HUE}',
      });
    },
  };
  /**
   * read dice from camera
   */
  Blockly.Blocks.read__dice_value = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.read__dice_value']);
      this.jsonInit({
        message0: _tt('%1 number of 🎲dice'),
        args0: [
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_SENSING);
    },
  };

  /**
   * PART 10: array
   */
  function getAllArrayOption() {
    const arrayOptions = Object.keys(blocklyStore.codeContextArrayVariables).reduce((acc, curr) => {
      acc.push([`${curr}`, `${curr}`]);
      return acc;
    }, []);
    if (arrayOptions.length <= 0) {
      arrayOptions.push(['none', 'none']);
    }
    return arrayOptions;
  }
  /**
   * array declare
   */
  Blockly.Blocks.array_declare = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.array_declare']);
      this.appendDummyInput()
        .appendField(_tt('⛓ Declare an Array named: '))
        .appendField(new Blockly.FieldTextInput('myArray1'), 'ARRAY_NAME');
      this.setColour(330);
    },
  };
  /**
   * array set item
   */
  Blockly.Blocks.array_set_item = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.array_set_item']);
      this.jsonInit({
        message0: _tt('Set element: %1 to value: %2 in array: %3'),
        args0: [
          {
            type: 'input_value',
            name: 'KEY',
          },
          {
            type: 'input_value',
            name: 'VALUE',
          },
          {
            type: 'field_dropdown',
            name: 'ARRAY_NAME',
            options: getAllArrayOption,
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
      });
      this.setColour(330);
    },
  };
  /**
   * array get item
   */
  Blockly.Blocks.array_get_item = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.array_get_item']);
      this.jsonInit({
        message0: _tt('Get element %1 from array variable: %2'),
        args0: [
          {
            type: 'input_value',
            name: 'KEY',
          },
          {
            type: 'field_dropdown',
            name: 'ARRAY_NAME',
            options: getAllArrayOption,
          },
        ],
        output: 'any',
      });
      this.setColour(330);
    },
  };
  /**
   * get array length
   */
  Blockly.Blocks.array_length = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.array_length']);
      this.jsonInit({
        message0: _tt('Get array %1 length'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'ARRAY_NAME',
            options: getAllArrayOption,
          },
        ],
        output: 'Number',
      });
      this.setColour(330);
    },
  };

  /**
   * PART 10: effect
   * effect animation staff
   */
  function effectObjectFactoryByAnimationType(block, animationType) {
    return () => {
      let args = [['none', '0']];
      if (
        mapSpecs[classRoomStore.mapId] &&
        mapSpecs[classRoomStore.mapId].effectObjects
      ) {
        const { effectObjects } = mapSpecs[classRoomStore.mapId];

        const classRoomObjectsMap = classRoomStore.classRoomObjects;
        const effectObjKeys = Object.keys(effectObjects);
        const effectObjctsInMap = classRoomObjectsMap
          .values()
          .filter(it =>
            !!effectObjects[`${it.identifier}`] &&
            effectObjects[`${it.identifier}`].animationType === animationType)
          .map(it => [
            `${effectObjects[it.identifier].name} (#${effectObjects[it.identifier].id})`,
            `${effectObjects[it.identifier].id}`,
          ]);
        // const effectObjctsInMap = Object.keys(effectObjects).filter(id => ).map(id => [`${effectObjects[id].name}`, `${effectObjects[id].id}`]);
        if (effectObjctsInMap.length > 0) args = effectObjctsInMap;
      }
      return args;
    };
  }

  function effectAnimationOptionsFactoryByAnimationType(block) {
    return () => {
      const effectObjectName =
        parseInt(block.getFieldValue('EFFECT_OBJECT'), 10) || 0;
      let args = [['none', '0']];
      if (!effectObjectName) return args;
      if (!mapSpecs[classRoomStore.mapId]) return args;
      if (!mapSpecs[classRoomStore.mapId].effectObjects) return args;
      const { animationType, animations } = mapSpecs[
        classRoomStore.mapId
      ].effectObjects[effectObjectName];

      const onFireFrozenOptionFactory = () => {
        const aniInMap = Object.keys(animations).map(id => [
          `${animations[id].name}`,
          `${animations[id].id}`,
        ]);
        if (aniInMap.length > 0) args = aniInMap;
        return args;
      };

      switch (animationType) {
        case 'onFireFrozen':
          return onFireFrozenOptionFactory();
        default:
          return args;
      }
    };
  }
  /**
   * effect onFire
   */
  Blockly.Blocks.the3d__object_effect_onFire_frozen = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.the3d__object_effect_onFire_frozen']);
      this.jsonInit({
        message0: _tt('🎆 Sprite %1 perform %2'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'EFFECT_OBJECT',
            options: effectObjectFactoryByAnimationType(this, 'onFireFrozen'),
          },
          {
            type: 'field_dropdown',
            name: 'EFFECT_ANIMATION',
            options: effectAnimationOptionsFactoryByAnimationType(this),
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
        // muator: 'the3d__object_effect_muator',
      });
      this.setInputsInline(true);
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * effect nil
   */
  Blockly.Blocks.the3d__object_effect_nil_effect = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.the3d__object_effect_nil_effect']);
      this.jsonInit({
        message0: _tt('🎆 Sprite %1 perform effect'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'EFFECT_OBJECT',
            options: effectObjectFactoryByAnimationType(this, 'nilEffect'),
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * effect flying
   */
  Blockly.Blocks.the3d__object_effect_flying_height = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.the3d__object_effect_flying_height']);
      this.jsonInit({
        message0: _tt('🎆 Flying Sprite  %1 set radius to %2'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'EFFECT_OBJECT',
            options: effectObjectFactoryByAnimationType(this, 'flyingHeight'),
          },
          {
            type: 'input_value',
            name: 'VALUE_OF_KEY_Y',
            check: 'Number',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
        // muator: 'the3d__object_effect_muator',
      });
      this.setColour(COLOR_MOTION);
    },
  };

  /**
   * Last part: Beginner toolbox extra blockly
   * for beginner, turn angle by drop down list
   */
  Blockly.Blocks.motion_angle__turn = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_angle__turn']);
      this.jsonInit({
        message0: _tt('Bot %1 turn %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'ANGLE',
            options: [
              [_tt('left'), '-90'],
              [_tt('right'), '90'],
              [_tt('slight left'), '-45'],
              [_tt('slight right'), '45'],
              [_tt('left u-turn'), '-180'],
              [_tt('right u-turn'), '180'],
            ],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * for beginner, servo open/close
   * @sensor Servo (on-board)
   */
  Blockly.Blocks.motion_servo__beginner__open_close_toggle = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_servo__beginner__open_close_toggle']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 gripper'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'OPEN_CLOSE',
            options: [[_tt('open'), 'open'], [_tt('close'), 'close']],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_ONBOARD_GRIPPER);
    },
  };
  /**
   * for beginner, robot turn to angle
   */
  Blockly.Blocks.motion_angle__look = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_angle__look']);
      this.jsonInit({
        message0: _tt('Bot %1 look %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'ANGLE',
            options: [
              [_tt('Up/North'), '0'],
              [_tt('Right/East'), '90'],
              [_tt('Down/South'), '180'],
              [_tt('Left/West'), '270'],
            ],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * for beginner, robot move to X Y
   */
  Blockly.Blocks.motion_move__move_to_XY = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__move_to_XY']);
      this.jsonInit({
        message0: 'Bot %1 move to X: %2 Y: %3 cm',
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'POSITION_Y',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * for beginner, read X Y Angle from a robot
   */
  Blockly.Blocks.sensing__robotXYA = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__robotXYA']);
      this.jsonInit({
        message0: _tt('read %1 of Bot %2'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'DATA',
            options: [[_tt('x (cm)'), 'x'], [_tt('y (cm)'), 'y'], [_tt('angle (°)'), 'a']],
          },
          robotArg(this),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_POSITION);
    },
  };
  /**
   * for beginner, robot follow another object by half distance
   */
  Blockly.Blocks.beginner__motion_mirror__follow = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__motion_mirror__follow']);
      this.jsonInit({
        message0: _tt('Bot %1 follow %2'),
        args0: [robotArgByRole(this), robotArg(this, 'TARGET')],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * for beginner, robot grab object
   */
  Blockly.Blocks.motion_special__grab_object = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_special__grab_object']);
      this.jsonInit({
        message0: _tt('Bot %1 grab object at X: %2 cm Y: %3 cm'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'POSITION_Y',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * for beginner, robot drop object
   */
  Blockly.Blocks.motion_special__release_object = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_special__release_object']);
      this.jsonInit({
        message0: _tt('Bot %1 release object at X: %2 cm Y: %3 cm'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'POSITION_Y',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * for beginner, robot drive circle
   */
  Blockly.Blocks.beginner__motion_special__drive_in_circle = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__motion_special__drive_in_circle']);
      this.jsonInit({
        message0: _tt('Bot %1 drive %2 in circle'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'LEFT_RIGHT',
            options: [[_tt('left'), '1'], [_tt('right'), '2']],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  /**
   * for beginner, robot play sound using on-board buzzer, always enabled
   */
  Blockly.Blocks.beginner__play_song = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__play_song']);
      this.jsonInit({
        message0: _tt('Bot %1 play song %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'MUSIC',
            options: RTTTL_SONGS,
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SOUND);
    },
  };
  /**
   * for beginner, robot set headlights state
   */
  Blockly.Blocks.leddiffuser_set_on_state = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.leddiffuser_set_on_state']);
      this.jsonInit({
        type: 'leddiffuser_set_on_state',
        // message0: 'Bot %1 set Headlight color to %2',
        message0: _tt('Bot %1 set Headlight on %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_checkbox',
            name: 'HEADLIGHT_STATE_ON',
            checked: false,
          },
        ],
        inputsInline: true,
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '#5EC3D6',
      });
    },
  };
  /**
   * for beginner, robot set headlights color (on-board), always enabled
   */
  Blockly.Blocks.leddiffuser_set_color = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.leddiffuser_set_color']);
      this.jsonInit({
        type: 'leddiffuser_set_color',
        message0: _tt('Bot %1 set Headlight color to %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_colour',
            name: 'COLOR_PICKER',
            colour: '#ff0000',
          },
        ],
        inputsInline: true,
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '#5EC3D6',
      });
      this.getField('COLOR_PICKER')
        .setColours([
          '#000000',
          '#ffffff',
          '#ff0000',
          '#00ff00',
          '#0000ff',
          '#ffff00',
          '#ff00ff',
          '#00ffff',
          '#ff003f',
        ])
        .setColumns(3);
    },
  };
  /**
   * for beginner, robot set Single LED on/off
   * @sensor Single LED
   */
  Blockly.Blocks.beginner__LED_turn_onOff = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__LED_turn_onOff']);
      this.jsonInit({
        message0: _tt('Bot %1 🔌Add-on LED %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'ON_OFF',
            options: [[_tt('On'), '100'], [_tt('Off'), '0']],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * for beginner, robot set RGB-LED color one by one
   * @sensor RGB-LED
   */
  Blockly.Blocks.sight_led_strip_4_colors = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip_4_colors']);
      this.jsonInit({
        message0: _tt('Bot %1 🔌Add-on RGB-LED %2 %3 %4 %5'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'COLOR_1',
            check: 'obj_color',
          },
          {
            type: 'input_value',
            name: 'COLOR_2',
            check: 'obj_color',
          },
          {
            type: 'input_value',
            name: 'COLOR_3',
            check: 'obj_color',
          },
          {
            type: 'input_value',
            name: 'COLOR_4',
            check: 'obj_color',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * for beginner, robot set 8x8 LED Matrix pixels by drop down list
   * @sensor 8x8 LED Matrix
   */
  Blockly.Blocks.beginner__sight_led_matrix_display__show = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__sight_led_matrix_display__show']);
      this.jsonInit({
        message0: _tt('Bot %1 🔌Add-on LED Matrix display symbol %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'CODE',
            options: MATRIX_8_8_LIST,
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * for beginner, robot set 8x8 LED Matrix pixels by string, will keep scrolling until next LED matrix command
   * @sensor 8x8 LED Matrix
   */
  Blockly.Blocks.beginner__sight_led_matrix_display__set_text = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__sight_led_matrix_display__set_text']);
      this.jsonInit({
        message0: _tt('Bot %1 🔌Add-on LED Matrix display text %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_input',
            name: 'TEXT',
            text: 'CLOSED',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };
  /**
   * for beginner, system listens to button press event
   * @sensor Button
   */
  Blockly.Blocks.beginner__events__button_pushed = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__events__button_pushed']);
      this.jsonInit({
        message0: _tt('When bot %1 button pushed'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * for beginner, system listens to robot out of boundary event
   */
  Blockly.Blocks.events__on_edge_trigger_of_variable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.events__rising_edge_of_variable']);
      this.jsonInit({
        message0: _tt('When variable %1 %2 %3'),
        args0: [
          {
            type: 'input_value',
            name: 'PARAM1',
            check: ['Number', 'Boolean'],
          },
          {
            type: 'field_dropdown',
            name: 'CONDITION',
            options: [
              ['>', '>'],
              ['<', '<'],
              ['=', '==='],
              ['!=', '!='],
              ['>=', '>='],
              ['<=', '<='],
            ],
          },
          {
            type: 'input_value',
            name: 'PARAM2',
            check: ['Number', 'Boolean'],
          },
        ],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * for beginner, system listens to robot out of boundary event
   */
  Blockly.Blocks.beginner__events__out_of_boundary = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__events__out_of_boundary']);
      this.jsonInit({
        message0: _tt('When bot %1 drives off mat'),
        args0: [robotArgByRole(this, { blockAction: 'read' })],
        message1: '%1',
        args1: [
          {
            type: 'input_statement',
            name: 'CALLBACK',
            check: 'any',
          },
        ],
        nextStatement: 'on_event',
        previousStatement: 'on_event',
        inputsInline: true,
        tooltip: '',
        helpUrl: '',
      });
      this.setColour(COLOR_EVENTS);
    },
  };
  /**
   * for beginner, math + - x /
   */
  Blockly.Blocks.beginner_math_arithmetic = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner_math_arithmetic']);
      this.jsonInit({
        message0: '%1 %2 %3',
        args0: [
          {
            type: 'input_value',
            name: 'A',
            check: 'Number',
          },
          {
            type: 'field_dropdown',
            name: 'OP',
            options: [
              ['%{BKY_MATH_ADDITION_SYMBOL}', 'ADD'],
              ['%{BKY_MATH_SUBTRACTION_SYMBOL}', 'MINUS'],
              ['%{BKY_MATH_MULTIPLICATION_SYMBOL}', 'MULTIPLY'],
              ['%{BKY_MATH_DIVISION_SYMBOL}', 'DIVIDE'],
            ],
          },
          {
            type: 'input_value',
            name: 'B',
            check: 'Number',
          },
        ],
        inputsInline: true,
        output: 'Number',
        style: 'math_blocks',
        helpUrl: '%{BKY_MATH_ARITHMETIC_HELPURL}',
        extensions: ['math_op_tooltip'],
      });
      this.setColour(Blockly.Constants.Math.HUE);
    },
  };
  /**
   * for beginner, read ultrasonic sensor
   * @sensor
   */
  Blockly.Blocks.beginner__sensing__ultrasonic_distance_sensor = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__sensing__ultrasonic_distance_sensor']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 Distance Sensor'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        output: 'Number',
      });
      this.setColour(COLOR_ONBOARD_ULTRASONIC);
    },
  };

  /*
   * old code not used anymore
   */
  const getSyncModeArg = () => {
    const _tt = getNS([KEY_I18N_ROOT_NS, 'func:getSyncModeArg']);
    return {
      type: 'field_dropdown',
      name: 'MODE',
      options: [[_tt('synchronously'), '1'], [_tt('asynchronously'), '2']],
    };
  };

  Blockly.Blocks.motion_move__park = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__park']);
      const parkings = [];
      for (
        let i = 1;
        i <= Object.keys(mapSpecs[classRoomStore.mapId].parking).length;
        i += 1
      ) {
        parkings.push([`${i}`, `${i}`]);
      }
      this.jsonInit({
        message0: _tt('Bot %1 park in slot %2 %3'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'INDEX',
            options: parkings,
          },
          getSyncModeArg(),
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  Blockly.Blocks.text__print = {
    init() {
      this.jsonInit({
        message0: Blockly.Msg.TEXT_PRINT_TITLE,
        args0: [
          {
            type: 'input_value',
            name: 'TEXT',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '%{BKY_TEXTS_HUE}',
        tooltip: Blockly.Msg.TEXT_PRINT_TOOLTIP,
        helpUrl: Blockly.Msg.TEXT_PRINT_HELPURL,
      });
    },
  };

  Blockly.Blocks.sensing__mapMarkXY = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__mapMarkXY']);
      this.jsonInit({
        message0: _tt('read %1 of map mark position (cm)'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'POSITION_NAME',
            options: () => [['X', 'mapX'], ['Y', 'mapY']],
          },
        ],
        output: 'Number',
      });
      this.setColour(COLOR_POSITION);
    },
  };

  Blockly.Blocks.motion_move__move_to_XY_with_self_adjustment = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__move_to_XY_with_self_adjustment']);
      this.jsonInit({
        message0: _tt('Bot %1 move to X: %2 Y: %3 cm ⇨ with accurate adjustments'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'POSITION_Y',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  Blockly.Blocks.motion_move__move_to_XY_stop_distance_with_self_adjustment = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_move__move_to_XY_stop_distance_with_self_adjustment']);
      this.jsonInit({
        message0:
          _tt('Bot %1 move to X: %2 Y: %3 cm ⇨ stop at distance %4 cm ⇨ with accurate adjustments'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'POSITION_Y',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'DISTANCE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.motion_mirror__follow = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_mirror__follow']);
      this.jsonInit({
        message0: _tt('Bot %1 follow bot %2 by %3 cm away'),
        args0: [
          robotArgByRole(this),
          robotArg(this, 'TARGET'),
          {
            type: 'input_value',
            name: 'DISTANCE',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.motion_special__grab_object_by_halfway = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_special__grab_object_by_halfway']);
      this.jsonInit({
        message0: _tt('Bot %1 grab object at X: %2 cm Y: %3 cm by Halfway'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'POSITION_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'POSITION_Y',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.motion_special__oval = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.motion_special__oval']);
      this.jsonInit({
        message0: _tt('Bot %1 oval (diameter X %2 cm Y %3 cm) %4'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'DIAMETER_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'DIAMETER_Y',
            check: 'Number',
          },
          {
            type: 'field_dropdown',
            name: 'LEFT_RIGHT',
            options: [[_tt('Left'), 'LEFT'], [_tt('Right'), 'RIGHT']],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  /*
   * define on-board blockly
   * 1, motion_servo__open_close_toggle
   * 2, motion_move__stop
   * 3,
   */

  Blockly.Blocks.beginner__headlights_set_colorObj = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.beginner__headlights_set_colorObj']);
      this.jsonInit({
        message0: _tt('Bot %1 Headlights %2'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'COLOR',
            check: 'obj_color',
          },
        ],
        inputsInline: true,
        previousStatement: 'any',
        nextStatement: 'any',
        colour: '#5EC3D6',
      });
    },
  };

  Blockly.Blocks.sensing__led__read_whether_on = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__led__read_whether_on']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on LED On-status (Boolean)'),
        args0: [
          robotArgByRole(this, { blockAction: 'read' }),
          getStrongText('read'),
        ],
        inputsInline: true,
        output: 'Boolean',
      });
      this.setColour(COLOR_SIGHT_INPUT);
    },
  };
  Blockly.Blocks.sight_led__switch = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led__switch']);
      this.jsonInit({
        message0: _tt('Bot %1 %2 🔌Add-on LED On-status %3'),
        args0: [
          robotArgByRole(this),
          getStrongText('set'),
          {
            type: 'input_value',
            name: 'ON_OFF',
            check: 'Boolean',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };

  Blockly.Blocks.sensing__rgb_color = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__rgb_color']);
      this.jsonInit({
        message0: _tt('Bot %1 read RGB-LED color at position %2'),
        args0: [
          robotArgBySensor(this, 'S4'),
          {
            type: 'field_dropdown',
            name: 'INDEX',
            options: [['1', '0'], ['2', '1'], ['3', '2'], ['4', '3']],
          },
        ],
        output: 'Number',
      });
      this.setColour(COLOR_SENSING);
    },
  };

  Blockly.Blocks.sensing__tube_display = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__tube_display']);
      this.jsonInit({
        message0: _tt('Bot %1 read 4digit display %2'),
        args0: [
          robotArgBySensor(this, 'S4'),
          {
            type: 'field_dropdown',
            name: 'INDEX',
            options: [[_tt('minutes'), '0'], [_tt('seconds'), '1']],
          },
        ],
        output: 'Number',
      });
      this.setColour(COLOR_SENSING);
    },
  };

  Blockly.Blocks.sight_led__color = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led__color']);
      this.jsonInit({
        message0: _tt('LED Colour: %1'),
        args0: [
          {
            type: 'field_colour',
            name: 'COLOUR',
            colour: '#ff0000',
          },
        ],
        output: 'Number',
      });
      this.setColour(COLOR_SIGHT);
      this.getField('COLOUR')
        .setColours([
          '#000000',
          '#ffffff',
          '#ff0000',
          '#00ff00',
          '#0000ff',
          '#ffff00',
          '#ff00ff',
          '#00ffff',
          '#ff003f',
        ])
        .setColumns(3);
    },
  };

  Blockly.Blocks.sight_led_strip__light = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip__light']);
      this.jsonInit({
        message0: 'Bot %1 RGB-LED position #%2 by intensity %3 %% color %4',
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'INDEX',
            check: 'Number',
          },
          {
            type: 'field_dropdown',
            name: 'BRIGHTNESS',
            options: [['10', '10'], ['50', '50'], ['100', '100']],
          },
          {
            type: 'field_colour',
            name: 'COLOUR',
            colour: '#ff0000',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
      this.getField('COLOUR')
        .setColours([
          '#000000',
          '#ffffff',
          '#ff0000',
          '#00ff00',
          '#0000ff',
          '#ffff00',
          '#ff00ff',
          '#00ffff',
          '#ff003f',
        ])
        .setColumns(3);
    },
  };

  Blockly.Blocks.sight_led_strip__light_off = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_led_strip__light_off']);
      this.jsonInit({
        message0: _tt('Bot %1 RGB-LED position %2 off'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_dropdown',
            name: 'MODE',
            options: [
              ['1', '1'],
              ['2', '2'],
              ['3', '3'],
              ['4', '4'],
              ['all', '0'],
            ],
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
      });
      this.setColour(COLOR_SIGHT);
    },
  };

  Blockly.Blocks.sight_tube_display__show = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sight_tube_display__show']);
      this.jsonInit({
        message0: _tt('Bot %1 show %2:%3 on 4digit display'),
        args0: [
          robotArgByRole(this),
          {
            type: 'input_value',
            name: 'MINUTES',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'SECONDS',
            check: 'Number',
          },
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SIGHT);
    },
  };

  Blockly.Blocks.sendCommand = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sendCommand']);
      this.jsonInit({
        message0: _tt('%1 Send %2 command %3 with params %4'),
        args0: [
          robotArgByRole(this),
          {
            type: 'field_input',
            name: 'ACTUATOR',
            text: 'motor',
          },
          {
            type: 'field_input',
            name: 'COMMAND',
            text: '',
          },
          {
            type: 'field_input',
            name: 'PARAMS',
            text: '',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.is_robot_position_in_the_area = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.is_robot_position_in_the_area']);
      this.jsonInit({
        message0: _tt('is Bot %1 at %2 within %3 CM'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'POSITION_XY',
            check: 'obj_position',
          },
          {
            type: 'input_value',
            name: 'DISTANCE',
            check: 'Number',
          },
        ],
        output: 'Boolean',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.microbit__send_message_to_microbit = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.microbit__send_message_to_microbit']);
      this.jsonInit({
        message0: _tt('Send message %1 to Micro:bit %2'),
        args0: [
          {
            type: 'input_value',
            name: 'TEXT',
            check: 'String',
          },
          robotArgByRole(this),
        ],
        nextStatement: 'any',
        previousStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MICROBIT);
    },
  };
  Blockly.Blocks.sensing__value_of_text_equals = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__value_of_text_equals']);
      this.jsonInit({
        message0: _tt('text %1 equals %2'),
        args0: [
          {
            type: 'input_value',
            name: 'TEXTA',
            // check: 'String',
          },
          {
            type: 'input_value',
            name: 'TEXTB',
            // check: 'String',
          },
        ],
        output: 'Boolean',
        inputsInline: true,
        colour: '%{BKY_LOGIC_HUE}',
      });
    },
  };
  Blockly.Blocks.sensing__value_of_text_contains = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__value_of_text_contains']);
      this.jsonInit({
        message0: _tt('text %1 contains %2'),
        args0: [
          {
            type: 'input_value',
            name: 'TEXTA',
            // check: 'String',
          },
          {
            type: 'input_value',
            name: 'TEXTB',
            // check: 'String',
          },
        ],
        output: 'Boolean',
        inputsInline: true,
        colour: '%{BKY_LOGIC_HUE}',
      });
    },
  };
  Blockly.Blocks.sensing__value_of_text_append = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__value_of_text_append']);
      this.jsonInit({
        message0: _tt('text %1 append %2'),
        args0: [
          {
            type: 'input_value',
            name: 'TEXTA',
            // check: 'any',
          },
          {
            type: 'input_value',
            name: 'TEXTB',
            // check: 'any',
          },
        ],
        output: 'String',
        inputsInline: true,
        colour: '%{BKY_TEXTS_HUE}',
      });
    },
  };
  Blockly.Blocks.sensing__value_of_text_length = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__value_of_text_length']);
      this.jsonInit({
        message0: _tt('length of text %1'),
        args0: [
          {
            type: 'input_value',
            name: 'TEXT',
            check: 'String',
          },
        ],
        output: 'Number',
        colour: '%{BKY_MATH_HUE}',
      });
    },
  };
  Blockly.Blocks.sensing__value_of_text_substring = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sensing__value_of_text_substring']);
      this.jsonInit({
        message0: _tt('sub-string of text %1 from %2 to %3'),
        args0: [
          {
            type: 'input_value',
            name: 'TEXT',
            // check: 'String',
          },
          {
            type: 'input_value',
            name: 'FROM',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'TO',
            check: 'Number',
          },
        ],
        output: 'String',
        inputsInline: true,
        colour: '%{BKY_TEXTS_HUE}',
      });
    },
  };
  // sandbox
  function sandboxViewerEffectNameOptions() {
    const _tt = getNS([KEY_I18N_ROOT_NS, 'func:sandboxViewerEffectNameOptions']);
    return [
      [_tt('None'), 'None'],
      [_tt('Fire'), 'Fire'],
      [_tt('Smoke'), 'Smoke'],
      [_tt('Rain'), 'Rain'],
      [_tt('Lightning'), 'Lightning'],
      [_tt('Sparkle'), 'Sparkle'],
      [_tt('Bullet'), 'Bullet'],
      [_tt('Stars'), 'Stars'],
      [_tt('Ice'), 'Ice'],
      [_tt('Magic'), 'Magic'],
      [_tt('Firework'), 'Firework'],
    ];
  }

  function sandboxViewerWhenEffectOptions() {
    const _tt = getNS([KEY_I18N_ROOT_NS, 'func:sandboxViewerWhenEffectOptions']);
    return [
      [_tt('moves'), 'moves'],
      [_tt('idle'), 'idle'],
      [_tt('one shot'), 'one_shot'],
    ];
  }

  function sandboxViewerAnimationOptions() {
    const _tt = getNS([KEY_I18N_ROOT_NS, 'func:sandboxViewerAnimationOptions']);
    return [
      [_tt('No animation'), 'NoAnim'],
      [_tt('Walk'), 'Walk'],
      [_tt('Bounce'), 'Bounce'],
      [_tt('Hover (floating above ground)'), 'Hover'],
      [_tt('Teleport'), 'Teleport'],
      [_tt('Spin'), 'Spin'],
      [_tt('Shake'), 'Shake'],
      [_tt('Dig'), 'Dig'],
      [_tt('Jump'), 'Jump'],
      [_tt('Forward flip'), 'Forward flip'],
      [_tt('Back flip'), 'Back flip'],
      [_tt('Idle'), 'Idle'],
    ];
  }

  function sandboxViewerSoundOptions() {
    const _tt = getNS([KEY_I18N_ROOT_NS, 'func:sandboxViewerSoundOptions']);
    return [
      [_tt('None'), 'None'],
      [_tt('Explosion'), 'Explosion'],
      [_tt('Lightning'), 'Lightning'],
      [_tt('Rain'), 'Rain'],
      [_tt('Footstep'), 'Footstep'],
      [_tt('Thud'), 'Thud'],
      [_tt('Alarm'), 'Alarm'],
      [_tt('Cow'), 'Cow'],
      [_tt('Dog'), 'Dog'],
      [_tt('Rooster'), 'Rooster'],
      [_tt('Bird'), 'Bird'],
      [_tt('Bees'), 'Bees'],
      [_tt('Duck'), 'Duck'],
      [_tt('ButtonOn'), 'ButtonOn'],
      [_tt('ButtonOff'), 'ButtonOff'],
      [_tt('Pop'), 'Pop'],
      [_tt('CartoonUp'), 'CartoonUp'],
      [_tt('CartoonDown'), 'CartoonDown'],
      [_tt('CartoonBoth'), 'CartoonBoth'],
      [_tt('SciFiHover'), 'SciFiHover'],
      [_tt('Camera'), 'Camera'],
      [_tt('Fire'), 'Fire'],
      [_tt('Splash'), 'Splash'],
      [_tt('Water'), 'Water'],
      [_tt('Engine'), 'Engine'],
      [_tt('Fireworks'), 'Fireworks'],
      [_tt('BalloonFart'), 'BalloonFart'],
      [_tt('Rubber'), 'Rubber'],
      [_tt('Can'), 'Can'],
      [_tt('Book'), 'Book'],
      [_tt('Chain'), 'Chain'],
      [_tt('Tape'), 'Tape'],
      [_tt('Scribble'), 'Scribble'],
      [_tt('Spray'), 'Spray'],
      [_tt('Paint'), 'Paint'],
      [_tt('Flush'), 'Flush'],
      [_tt('Splat'), 'Splat'],
      [_tt('Burp'), 'Burp'],
      [_tt('ImpactMetal'), 'ImpactMetal'],
      [_tt('ImpactEnergy'), 'ImpactEnergy'],
      [_tt('Ding'), 'Ding'],
      [_tt('Impact'), 'Impact'],
      [_tt('LawnMower'), 'LawnMower'],
      [_tt('Magic'), 'Magic'],
      [_tt('MagicBullet'), 'MagicBullet'],
      [_tt('GameDown'), 'GameDown'],
      [_tt('GameOver'), 'GameOver'],
      [_tt('GameTune'), 'GameTune'],
      [_tt('GameTuneAlt'), 'GameTuneAlt'],
      [_tt('GameLevel'), 'GameLevel'],
      [_tt('GameVictory'), 'GameVictory'],
      [_tt('GameDunDun'), 'GameDunDun'],
      [_tt('Shatter'), 'Shatter'],
      [_tt('SciFiWarp'), 'SciFiWarp'],
      [_tt('Thruster'), 'Thruster'],
      [_tt('Helicopter'), 'Helicopter'],
      [_tt('SteamTrain'), 'SteamTrain'],
      [_tt('Truck'), 'Truck'],
      [_tt('Powerboat'), 'Powerboat'],
      [_tt('Sonar'), 'Sonar'],
      [_tt('Archery'), 'Archery'],
      [_tt('Bullet'), 'Bullet'],
      [_tt('Reload'), 'Reload'],
      [_tt('Blaster'), 'Blaster'],
      [_tt('Plasma'), 'Plasma'],
      [_tt('Whoosh'), 'Whoosh'],
    ];
  }
  function sandboxViewerEvnironmentOptions() {
    const _tt = getNS([KEY_I18N_ROOT_NS, 'func:sandboxViewerEvnironmentOptions']);
    return [
      [_tt('Cliffside'), 'Cliffside'],
      [_tt('Desert'), 'Desert'],
      [_tt('SciFi'), 'SciFi'],
    ];
  }

  function sandboxViewerCrunchOptions() {
    const _tt = getNS([KEY_I18N_ROOT_NS, 'func:sandboxViewerCrunchOptions']);
    return [
      ['0', '0'],
      ['1', '1'],
      ['2', '2'],
    ];
  }
  /* sandbox
   *              _____                    _____                    _____                    _____                    _____                   _______
   *             /\    \                  /\    \                  /\    \                  /\    \                  /\    \                 /::\    \                ______
   *            /::\    \                /::\    \                /::\____\                /::\    \                /::\    \               /::::\    \              |::|   |
   *           /::::\    \              /::::\    \              /::::|   |               /::::\    \              /::::\    \             /::::::\    \             |::|   |
   *          /::::::\    \            /::::::\    \            /:::::|   |              /::::::\    \            /::::::\    \           /::::::::\    \            |::|   |
   *         /:::/\:::\    \          /:::/\:::\    \          /::::::|   |             /:::/\:::\    \          /:::/\:::\    \         /:::/~~\:::\    \           |::|   |
   *        /:::/__\:::\    \        /:::/__\:::\    \        /:::/|::|   |            /:::/  \:::\    \        /:::/__\:::\    \       /:::/    \:::\    \          |::|   |
   *        \:::\   \:::\    \      /::::\   \:::\    \      /:::/ |::|   |           /:::/    \:::\    \      /::::\   \:::\    \     /:::/    / \:::\    \         |::|   |
   *      ___\:::\   \:::\    \    /::::::\   \:::\    \    /:::/  |::|   | _____    /:::/    / \:::\    \    /::::::\   \:::\    \   /:::/____/   \:::\____\        |::|   |
   *     /\   \:::\   \:::\    \  /:::/\:::\   \:::\    \  /:::/   |::|   |/\    \  /:::/    /   \:::\ ___\  /:::/\:::\   \:::\ ___\ |:::|    |     |:::|    | ______|::|___|___ ____
   *    /::\   \:::\   \:::\____\/:::/  \:::\   \:::\____\/:: /    |::|   /::\____\/:::/____/     \:::|    |/:::/__\:::\   \:::|    ||:::|____|     |:::|    ||:::::::::::::::::|    |
   *    \:::\   \:::\   \::/    /\::/    \:::\  /:::/    /\::/    /|::|  /:::/    /\:::\    \     /:::|____|\:::\   \:::\  /:::|____| \:::\    \   /:::/    / |:::::::::::::::::|____|
   *     \:::\   \:::\   \/____/  \/____/ \:::\/:::/    /  \/____/ |::| /:::/    /  \:::\    \   /:::/    /  \:::\   \:::\/:::/    /   \:::\    \ /:::/    /   ~~~~~~|::|~~~|~~~
   *      \:::\   \:::\    \               \::::::/    /           |::|/:::/    /    \:::\    \ /:::/    /    \:::\   \::::::/    /     \:::\    /:::/    /          |::|   |
   *       \:::\   \:::\____\               \::::/    /            |::::::/    /      \:::\    /:::/    /      \:::\   \::::/    /       \:::\__/:::/    /           |::|   |
   *        \:::\  /:::/    /               /:::/    /             |:::::/    /        \:::\  /:::/    /        \:::\  /:::/    /         \::::::::/    /            |::|   |
   *         \:::\/:::/    /               /:::/    /              |::::/    /          \:::\/:::/    /          \:::\/:::/    /           \::::::/    /             |::|   |
   *          \::::::/    /               /:::/    /               /:::/    /            \::::::/    /            \::::::/    /             \::::/    /              |::|   |
   *           \::::/    /               /:::/    /               /:::/    /              \::::/    /              \::::/    /               \::/____/               |::|   |
   *            \::/    /                \::/    /                \::/    /                \::/____/                \::/____/                 ~~                     |::|___|
   *             \/____/                  \/____/                  \/____/                  ~~                       ~~                                               ~~
   *
   *
   *
   */

  /**
   * sandbox 0-1
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_theme_clear = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_theme_clear']);
      this.jsonInit({
        message0: _tt('Theme %1 clear %2'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'THEME',
            options: [
              ['Cliffside', 'Cliffside'],
              ['Desert', 'Desert'],
              ['Space', 'Space'],
              ['Chess', 'Chess'],
            ],
          },
          {
            type: 'field_dropdown',
            name: 'ITEM',
            options: [
              ['None', 'None'],
              ['Tiles', 'Tiles'],
              ['Everything', 'Everything'],
            ],
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-2
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_load_video_youtube = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_load_video_youtube']);
      this.jsonInit({
        message0: _tt('Bot Avatar %1 load Youtube video %2 %3 🔁 %4 %5 at volume %6 %%'),
        args0: [
          robotArg(this),
          {
            type: 'field_input',
            name: 'URL',
            text: 'default',
          },
          {
            type: 'input_dummy',
          },
          {
            type: 'field_dropdown',
            name: 'LOOP',
            options: [
              ['once', 'false'],
              ['loop', 'true'],
            ],
          },
          {
            type: 'field_dropdown',
            name: 'SCREEN',
            options: [
              ['normal', 'false'],
              ['full screen', 'true'],
            ],
          },
          {
            type: 'field_dropdown',
            name: 'VOL',
            options: [
              ['10%', '10'],
              ['50%', '50'],
              ['100%', '100'],
            ],
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: false,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-3
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_spawn_3d_model = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_spawn_3d_model']);
      this.jsonInit({
        message0: _tt('Spawn 3D Model %1 to X %2 Y %3(cm), duration %4 seconds'),
        args0: [
          generate3DModelArg(),
          {
            type: 'input_value',
            name: 'X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'Y',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'DURATION',
            check: 'Number',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-4
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_speech_bubbles = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_speech_bubbles']);
      this.jsonInit({
        message0: _tt('Clear all speech bubbles'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-4
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_clear_video = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_clear_video']);
      this.jsonInit({
        message0: _tt('Clear all videos'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-5
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_model_animations = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_model_animations']);
      this.jsonInit({
        message0: _tt('Clear all animations'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-6
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_tiles = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_tiles']);
      this.jsonInit({
        message0: _tt('Clear all terrains'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-7
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_trailes = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_trailes']);
      this.jsonInit({
        message0: _tt('Clear all paint trailes'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-8
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_transforms = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_clear_all_transforms']);
      this.jsonInit({
        message0: _tt('Clear all transforms'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-9
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_clear_everything = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_clear_everything']);
      this.jsonInit({
        message0: _tt('Clear everything'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-10
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_mute_all_sounds = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_mute_all_sounds']);
      this.jsonInit({
        message0: _tt('Mute all sounds'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-11
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_enable_all_sounds = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_enable_all_sounds']);
      this.jsonInit({
        message0: _tt('Enable all sounds'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-12
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_load_skybox_url = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_load_skybox_url']);
      this.jsonInit({
        message0: _tt('Load Skybox %1 %2'),
        args0: [
          {
            type: 'input_dummy',
          },
          {
            type: 'field_input',
            name: 'URL',
            text: 'default',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };
  /**
   * sandbox 0-13
   */
  Blockly.Blocks.sandbox_viewer_teacher_only_change_sun_color = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_teacher_only_change_sun_color']);
      this.jsonInit({
        message0: _tt('Change Sun Color %1'),
        args0: [
          {
            type: 'field_colour',
            name: 'COLOUR',
            colour: '#ff0000',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
      this.getField('COLOUR')
        .setColours([
          '#000000',
          '#ffffff',
          '#ff0000',
          '#00ff00',
          '#0000ff',
          '#ffff00',
          '#ff00ff',
          '#00ffff',
          '#ff003f',
        ])
        .setColumns(3);
    },
  };
  /**
   * sandbox 1-1
   */
  Blockly.Blocks.sandbox_viewer_download_by_file_name = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_download_by_file_name']);
      this.jsonInit({
        message0: _tt('Load Avatar %1 to Bot %2'),
        args0: [
          // {
          //   type: 'field_input',
          //   name: 'DOWNLOAD_FILE_NAME',
          //   text: '',
          // },
          generate3DModelArg(),
          robotArg(this),
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 2-1
   */
  Blockly.Blocks.sandbox_viewer_transform_rotate_object_by_XYZ_degrees = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_transform_rotate_object_by_XYZ_degrees']);
      this.jsonInit({
        message0: _tt('Bot Avatar %1 rotate by X:%2 Y:%3 Z:%4 degrees'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'RO_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'RO_Y',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'RO_Z',
            check: 'Number',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 2-2
   */
  Blockly.Blocks.sandbox_viewer_transform_rotate_object_by_XYZ_degrees_with_angle_selector = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_transform_rotate_object_by_XYZ_degrees_with_angle_selector']);
      this.jsonInit({
        message0: _tt('Bot Avatar %1 rotate by X:%2 Y:%3 Z:%4 degrees'),
        args0: [
          robotArg(this),
          {
            type: 'field_angle',
            name: 'RO_X',
            angle: 0,
          },
          {
            type: 'field_angle',
            name: 'RO_Y',
            angle: 0,
          },
          {
            type: 'field_angle',
            name: 'RO_Z',
            angle: 0,
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 2-2-1
   */
  Blockly.Blocks.sandbox_viewer_transform_rotate_object_by_left_right = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_transform_rotate_object_by_left_right']);
      this.jsonInit({
        message0: _tt('Rotate Bot Avatar %1 %2'),
        args0: [
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'DIRECTION',
            options: [
              ['left', '-90'],
              ['right', '90'],
            ],
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 2-3
   */
  Blockly.Blocks.sandbox_viewer_transform_rotate_object_reset = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_transform_rotate_object_reset']);
      this.jsonInit({
        message0: _tt('Bot Avatar %1 reset rotation'),
        args0: [
          robotArg(this),
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 2-4
   */
  Blockly.Blocks.sandbox_viewer_transform_scale_object_by_all_persentage = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_transform_scale_object_by_all_persentage']);
      this.jsonInit({
        message0: _tt('Bot Avatar %1 scale by %2'),
        args0: [
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'SCALE',
            options: [
              ['200%', '200'],
              ['190%', '190'],
              ['170%', '170'],
              ['150%', '150'],
              ['100%', '100'],
              ['50%', '50'],
              ['30%', '30'],
              ['10%', '10'],
            ],
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 2-5
   */
  Blockly.Blocks.sandbox_viewer_transform_scale_object_by_XYZ_persentage = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_transform_scale_object_by_XYZ_persentage']);
      this.jsonInit({
        message0: _tt('Bot Avatar %1 scale by X:%2%% Y:%3%% Z:%4%%'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'SCALE_X',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'SCALE_Y',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'SCALE_Z',
            check: 'Number',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 2-6
   */
  Blockly.Blocks.sandbox_viewer_transform_scale_object_reset = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_transform_scale_object_reset']);
      this.jsonInit({
        message0: _tt('Bot Avatar %1 reset scale'),
        args0: [
          robotArg(this),
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 2-7
   */
  Blockly.Blocks.sandbox_viewer_transform_fly_object_by_height = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_transform_fly_object_by_height']);
      this.jsonInit({
        message0: _tt('Bot Avatar %1 fly at height %2 cm'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'HEIGHT',
            check: 'Number',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 3-1
   */
  Blockly.Blocks.sandbox_viewer_animations_play = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_animations_play']);
      this.jsonInit({
        message0: _tt('Play animation %1 on Bot Avatar %2 when %3'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'ANIMATION_NAME',
            options: sandboxViewerAnimationOptions,
          },
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'WHEN',
            options: sandboxViewerWhenEffectOptions,
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 3-2
   */
  Blockly.Blocks.sandbox_viewer_animations_stop = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_animations_stop']);
      this.jsonInit({
        message0: _tt('Stop animation on Bot Avatar %1'),
        args0: [
          robotArg(this),
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 3-3
   */
  Blockly.Blocks.sandbox_viewer_animation_orbit = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_animation_orbit']);
      this.jsonInit({
        message0: _tt('Orbit Bot Avatar %1 at angle %2, radius %3cm, speed %4'),
        args0: [
          robotArg(this),
          {
            type: 'field_angle',
            name: 'ANGLE',
            angle: 90,
          },
          {
            type: 'input_value',
            name: 'RADIUS',
            check: 'Number',
          },
          {
            type: 'field_dropdown',
            name: 'SPEED',
            options: [
              ['slow', '1'],
              ['normal', '2'],
              ['fast', '3'],
            ],
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 4-1
   */
  Blockly.Blocks.sandbox_viewer_effects_enable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_effects_enable']);
      this.jsonInit({
        message0: _tt('Play effect %1 %2 on Bot Avatar %3 when %4'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'EFFECT_NAME',
            options: sandboxViewerEffectNameOptions,
          },
          {
            type: 'input_value',
            name: 'COLOR',
            check: ['obj_color'],
          },
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'WHEN',
            options: sandboxViewerWhenEffectOptions,
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 4-2
   */
  Blockly.Blocks.sandbox_viewer_effect_clear = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_effect_clear']);
      this.jsonInit({
        message0: _tt('Clear effects on Bot Avatar %1'),
        args0: [
          robotArg(this),
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 4-3
   */
  Blockly.Blocks.sandbox_viewer_effects_shoot = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_effects_shoot']);
      this.jsonInit({
        message0: _tt('Shoot effect from Bot Avatar %1 with colour %2'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'COLOR',
            check: ['obj_color'],
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 4-4
   */
  Blockly.Blocks.sandbox_viewer_ghost_robot = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_ghost_robot']);
      this.jsonInit({
        message0: _tt('Ghost Bot Avatar %1 by %2'),
        args0: [
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'RATIO',
            options: [
              ['NO CHANGE', '0'],
              ['10%', '10'],
              ['50%', '50'],
              ['100%', '100'],
            ],
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 5-1
   */
  Blockly.Blocks.sandbox_viewer_trail_enable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_trail_enable']);
      this.jsonInit({
        message0: _tt('Paint trail with %1 & %2 on Bot Avatar %3 with width %4 for %5 seconds'),
        args0: [
          {
            type: 'input_value',
            name: 'START_COLOUR',
            check: ['obj_color'],
          },
          {
            type: 'input_value',
            name: 'END_COLOUR',
            check: ['obj_color'],
          },
          robotArg(this),
          {
            type: 'input_value',
            name: 'WIDTH',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'DURATION',
            check: 'Number',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 5-1-1
   */
  Blockly.Blocks.sandbox_viewer_trail_enable_beginner = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_trail_enable_beginner']);
      this.jsonInit({
        message0: _tt('Paint trail on Bot Avatar %1'),
        args0: [
          robotArg(this),
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 5-2
   */
  Blockly.Blocks.sandbox_viewer_trail_disable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_trail_disable']);
      this.jsonInit({
        message0: _tt('Remove paint trail on Bot Avatar %1'),
        args0: [
          robotArg(this),
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 6-1
   */
  Blockly.Blocks.sandbox_viewer_tile_build = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_tile_build']);
      this.jsonInit({
        message0: _tt('Build terrain with Bot Avatar %1 at layer %2, activate %3'),
        args0: [
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'LAYER',
            options: [
              ['1', '1'],
              ['2', '2'],
            ],
          },
          {
            type: 'input_value',
            name: 'ACTIVATE',
            check: 'Boolean',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 6-1-1
   */
  Blockly.Blocks.sandbox_viewer_tile_build_beginner = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_tile_build_beginner']);
      this.jsonInit({
        message0: _tt('Build terrain with Bot Avatar %1, activate %2'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'ACTIVATE',
            check: 'Boolean',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 6-2
   */
  Blockly.Blocks.sandbox_viewer_tile_destroy = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_tile_destroy']);
      this.jsonInit({
        message0: _tt('Remove terrain with Bot Avatar %1 at layer %2, activate %3'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'LAYER',
            check: 'Number',
          },
          {
            type: 'input_value',
            name: 'ACTIVATE',
            check: 'Boolean',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 6-2-1
   */
  Blockly.Blocks.sandbox_viewer_tile_destroy_beginner = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_tile_destroy_beginner']);
      this.jsonInit({
        message0: _tt('Remove terrain with Bot Avatar %1, activate %2'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'ACTIVATE',
            check: 'Boolean',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 7-1
   */
  Blockly.Blocks.sandbox_viewer_sounds_enable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_sounds_enable']);
      this.jsonInit({
        message0: _tt('Sound %1 on Bot Avatar %2 when object %3'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'SOUND_NAME',
            options: sandboxViewerSoundOptions,
          },
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'WHEN',
            options: sandboxViewerWhenEffectOptions,
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 7-2
   */
  Blockly.Blocks.sandbox_viewer_sounds_disable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_sounds_disable']);
      this.jsonInit({
        message0: _tt('Stop all sounds on Bot Avatar %1'),
        args0: [
          robotArg(this),
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  /**
   * sandbox 8-1
   */
  Blockly.Blocks.sandbox_viewer_speech_show_info_panel_with_custom_colour = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_speech_show_info_panel_with_custom_colour']);
      this.jsonInit({
        message0: _tt('Speech Bubble %1 on Bot Avatar %2 with background %3 text %4 for %5 seconds'),
        args0: [
          {
            type: 'input_value',
            name: 'TEXT_INPUT',
            check: 'String',
          },
          robotArg(this),
          {
            type: 'input_value',
            name: 'BUBBLE_COLOUR',
            check: ['obj_color'],
          },
          {
            type: 'input_value',
            name: 'TEXT_COLOUR',
            check: ['obj_color'],
          },
          {
            type: 'input_value',
            name: 'DURATION',
            check: 'Number',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  // /**
  //  * sandbox 8-2
  //  */
  // Blockly.Blocks.sandbox_viewer_speech_show_info_panel = {
  //   init() {
  //     const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_speech_show_info_panel']);
  //     this.jsonInit({
  //       message0: _tt('Speech Bubble %1 on Bot Avatar %2'),
  //       args0: [
  //         {
  //           type: 'field_input',
  //           name: 'TEXT',
  //           text: '',
  //         },
  //         robotArg(this),
  //       ],
  //       previousStatement: 'any',
  //       nextStatement: 'any',
  //       inputsInline: true,
  //     });
  //     this.setColour(COLOR_SANDBOX);
  //   },
  // };
  /**
   * sandbox 8-3
   */
  Blockly.Blocks.sandbox_viewer_speech_show_emoji = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_speech_show_emoji']);
      this.jsonInit({
        message0: _tt('Emoji on Bot Avatar %1 %2'),
        args0: [
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'EMOJI',
            options: [
              ['😄 Laughing', 'Laughing'],
              ['😠 Angry', 'Angry'],
              ['🤩 Like', 'Like'],
              ['😭 Cry', 'Cry'],
              ['🤪 Wow', 'Wow'],
              ['😍 Love', 'Love'],
            ],
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };
  Blockly.Blocks.call_builder_function = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.call_builder_function']);
      this.jsonInit({
        message0: _tt('Call builder function %1'),
        args0: [{ type: 'input_value', name: 'FUNCTION_NAME', check: 'String' }],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX);
    },
  };

  Blockly.Blocks.sandbox_viewer_general = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_general']);
      this.jsonInit({
        message0: _tt('Object Smoothing %1 Float %2'),
        args0: [
          robotArg(this),
          {
            type: 'input_value',
            name: 'SMOOTHING_MODIFIER',
            check: 'Number',
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.sandbox_viewer_crunch_enable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_crunch_enable']);
      this.jsonInit({
        message0: _tt('Paint terrain with object %1 at layer %2'),
        args0: [
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'LAYER',
            options: sandboxViewerCrunchOptions,
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  Blockly.Blocks.sandbox_viewer_crunch_disable = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_crunch_disable']);
      this.jsonInit({
        message0: _tt('Remove terrain with object %1 at layer %2'),
        args0: [
          robotArg(this),
          {
            type: 'field_dropdown',
            name: 'LAYER',
            options: sandboxViewerCrunchOptions,
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.sandbox_viewer_terrain = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_terrain']);
      this.jsonInit({
        message0: _tt('Change terrain %1'),
        args0: [
          {
            type: 'field_dropdown',
            name: 'ENVIRONMENT_NAME',
            options: sandboxViewerEvnironmentOptions,
          },
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.sandbox_viewer_clear = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_clear']);
      this.jsonInit({
        message0: _tt('Clear the entire scene'),
        args0: [],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };
  // sandbox ending

  Blockly.Blocks.sandbox_viewer_clear = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_clear']);
      this.jsonInit({
        message0: _tt('Clear the entire scene'),
        args0: [],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_MOTION);
    },
  };

  Blockly.Blocks.sandbox_viewer_spawn_random_collectables = {
    init() {
      const _tt = getNS([KEY_I18N_ROOT_NS, 'Blockly.Blocks.sandbox_viewer_spawn_random_collectables']);
      this.jsonInit({
        message0: _tt('Spawn random collectables'),
        args0: [
        ],
        previousStatement: 'any',
        nextStatement: 'any',
        inputsInline: true,
      });
      this.setColour(COLOR_SANDBOX_TEACHER_ONLY);
    },
  };

  // monkeypatch
  /* eslint-disable */
  // variable_set
  Blockly.defineBlocksWithJsonArray([  // BEGIN JSON EXTRACT
    // Block for variable getter.
    {
      "type": "variables_get",
      "message0": "%1",
      "args0": [
        {
          "type": "field_variable",
          "name": "VAR",
          "variable": "%{BKY_VARIABLES_DEFAULT_NAME}"
        }
      ],
      "output": null,
      "style": "variable_blocks",
      "helpUrl": "%{BKY_VARIABLES_GET_HELPURL}",
      "tooltip": "%{BKY_VARIABLES_GET_TOOLTIP}",
      "extensions": ["contextMenu_variableSetterGetter"]
    },
    // Block for variable setter.
    {
      "type": "variables_set",
      "message0": "%{BKY_VARIABLES_SET}",
      "args0": [
        {
          "type": "field_variable",
          "name": "VAR",
          "variable": "%{BKY_VARIABLES_DEFAULT_NAME}"
        },
        {
          "type": "input_value",
          "name": "VALUE"
        }
      ],
      "previousStatement": 'any',
      "nextStatement": 'any',
      "style": "variable_blocks",
      "tooltip": "%{BKY_VARIABLES_SET_TOOLTIP}",
      "helpUrl": "%{BKY_VARIABLES_SET_HELPURL}",
      "extensions": ["contextMenu_variableSetterGetter"]
    },
    // change variable by
    // Block for adding to a variable in place.
    {
      "type": "math_change",
      "message0": "%{BKY_MATH_CHANGE_TITLE}",
      "args0": [
        {
          "type": "field_variable",
          "name": "VAR",
          "variable": "%{BKY_MATH_CHANGE_TITLE_ITEM}"
        },
        {
          "type": "input_value",
          "name": "DELTA",
          "check": "Number"
        }
      ],
      "previousStatement": 'any',
      "nextStatement": 'any',
      "style": "variable_blocks",
      "helpUrl": "%{BKY_MATH_CHANGE_HELPURL}",
      "extensions": ["math_change_tooltip"]
    },
  ]);  // END JSON EXTRACT (Do not delete this comment.)

  // blockly: function -- call a function
  if (Blockly.Blocks['procedures_callnoreturn'] && Blockly.Blocks['procedures_callnoreturn'].init) {
    Blockly.Blocks['procedures_callnoreturn'].init = monkeyify(Blockly.Blocks['procedures_callnoreturn'].init, {
      allowMonkeyInMonkey: true,
      monkey: (caller, args, originalFunction) => {
        const r = originalFunction.apply(caller, args);
        caller.setPreviousStatement(true, ['runProgram', 'any']);
        // caller.setNextStatement('any');
        return r;
      },
    });
  }

  // blockly: function -- if return
  if (Blockly.Blocks['procedures_ifreturn'] && Blockly.Blocks['procedures_ifreturn'].init) {
    Blockly.Blocks['procedures_ifreturn'].init = monkeyify(Blockly.Blocks['procedures_ifreturn'].init, {
      allowMonkeyInMonkey: true,
      monkey: (caller, args, originalFunction) => {
        const r = originalFunction.apply(caller, args);
        caller.setPreviousStatement(true, ['runProgram', 'any']);
        // caller.setNextStatement('any');
        return r;
      },
    });
  }
}
